/**
 * Strings pt-PT.
 * Mais traducoes adicionadas com a evolucao do produto.
 */
const pt = {
  app: {
    name: 'EvPlanner',
    tagline: 'Planeia a tua evolução financeira.',
  },
  nav: {
    dashboard: 'Início',
    /** Cabeçalhos das 5 áreas do menu. */
    sections: {
      myMonth: 'O meu mês',
      savings: 'Poupança',
    },
    /** Itens do menu (substantivos). */
    expenseList: 'Lista de despesas',
    patrimonioOverview: 'Visão geral',
    calendarAnnual: 'Calendário anual',
    categoriesShort: 'Categorias',
    incomeHistory: 'Ver rendimentos',
    incomeSourcesShort: 'Fontes',
    pots: 'Cofres',
    bottomBarBadge: 'Bottom bar',
    /** Atalhos curtos (barra inferior mobile). */
    expenses: 'Despesas',
    /** Títulos de página (cabecalhos e links internos). */
    categories: 'Categorias de despesa',
    incomeSources: 'Fontes de rendimento',
    budget: 'Orçamento',
    accounts: 'Ativos',
    assets: 'Ativos',
    patrimonio: 'Património',
    goals: 'Objetivos',
    income: 'Rendimentos',
    emergencyFund: 'Fundo de Emergência',
    selfies: 'Selfies Financeiras',
    cycleSettings: 'Definições do ciclo',
    notifications: 'Notificações',
    reminders: 'Lembretes',
    appearance: 'Aparência',
    dividas: 'Dívidas',
    menu: 'Menu',
    back: 'Voltar',
    settings: 'Definições',
    quickActions: 'Acções rápidas',
    quickActionsTitle: 'O que queres criar?',
    create: 'Criar',
    searchPlaceholder: 'Procurar…',
    searchAriaLabel: 'Procurar despesas',
    notificationsBell: 'Alertas',
    notificationsEmpty: 'Sem alertas por agora.',
    notificationsSettingsLink: 'Definições de notificações',
    quickActionsExpense: 'Despesa',
    quickActionsExpenseHint: 'Registar um gasto',
    quickActionsIncome: 'Rendimento',
    quickActionsIncomeHint: 'Salário, freelance, outro',
    quickActionsIncomeSource: 'Nova fonte',
    quickActionsCategory: 'Categoria',
    quickActionsCategoryHint: 'Organizar despesas',
    quickActionsAsset: 'Ativo',
    quickActionsAssetHint: 'Conta, poupança, bem',
    quickActionsGoal: 'Objetivo',
    quickActionsGoalHint: 'Uma meta para poupar',
  },
  quickCreate: {
    dateToday: 'Hoje',
    dateYesterday: 'Ontem',
    optional: '(opcional)',
    accountLabel: 'Conta',
    accountPickerTitle: 'Escolher conta',
    moreAccountsShort: 'Mais contas',
    categoryLabel: 'Categoria',
    categoryPickerTitle: 'Escolher categoria',
    createFirstCategory: 'Criar a tua primeira categoria',
    createFirstCategoryDescription: 'Ainda não tens categorias. Cria uma agora para poderes guardar esta despesa.',
    createFirstCategoryInlineSubmit: 'Criar categoria',
    createFirstCategoryCancel: 'Cancelar',
    createFirstSource: 'Criar a tua primeira fonte',
    createFirstSourceDescription: 'Ainda não tens fontes. Cria uma agora para poderes guardar este rendimento.',
    createFirstSourceInlineSubmit: 'Criar fonte',
    createFirstSourceCancel: 'Cancelar',
    newCategory: 'Nova categoria',
    newCategoryShort: 'Nova',
    moreCategoriesShort: 'Mais',
    newSourceShort: 'Nova fonte',
    moreSourcesShort: 'Mais fontes',
    sourceLabel: 'Fonte',
    sourcePickerTitle: 'Escolher fonte',
    newSource: 'Nova fonte',
    dateLabel: 'Quando foi?',
    dateOtherLabel: 'Outra data',
    datePickerTitle: 'Escolher data',
    dateWeekdays: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
    datePrevMonth: 'Mês anterior',
    dateNextMonth: 'Mês seguinte',
    noteLabel: 'Nota',
    notePlaceholder: 'Acrescentar…',
    recurrenceLabel: 'Recorrente?',
    recurrence: {
      monthlyFixed: 'Todos os meses',
      monthlyVariable: 'Valor variável',
      occasional: 'Pontual / irregular',
    },
    allocation: {
      essential: 'Necessidades',
      lifestyle: 'Desejos',
      savings: 'Poupança e Investimento',
    },
    allocationLabel: 'Grupo do método',
    monthlyLimitLabel: 'Limite mensal',
    expense: {
      title: 'Nova despesa',
      amountLabel: 'Quanto gastaste?',
      submit: 'Guardar',
    },
    income: {
      title: 'Novo rendimento',
      amountLabel: 'Quanto recebeste?',
      submit: 'Guardar',
    },
    category: {
      title: 'Nova categoria',
      nameLabel: 'Como se chama?',
      namePlaceholder: 'Transportes',
      submit: 'Criar categoria',
      createdToast: 'Categoria criada.',
    },
    asset: {
      title: 'Novo ativo',
      nameLabel: 'Que ativo é?',
      namePlaceholder: 'Conta poupança',
      typeLabel: 'Tipo',
      types: {
        account: 'Conta',
        savings: 'Poupança',
        investment: 'Investimento',
        other: 'Bem / outro',
      },
      balanceLabel: 'Valor actual',
      submit: 'Criar ativo',
      createdToast: 'Ativo criado.',
    },
    goal: {
      title: 'Novo objetivo',
      nameLabel: 'O que queres alcançar?',
      namePlaceholder: 'Viagem ao Japão',
      targetAmountLabel: 'Valor-alvo',
      targetDateLabel: 'Até quando',
      submit: 'Criar objetivo',
      createdToast: 'Objectivo criado.',
    },
  },
  landing: {
    nav: {
      login: 'Entrar',
      cta: 'Começa grátis',
    },
    brand: {
      ev: 'Ev',
      planner: 'Planner',
    },
    hero: {
      badge: 'O teu dinheiro, mês a mês',
      title: 'Do descontrolo à calma de saber onde estás',
      subtitle:
        'Organiza o teu dinheiro sem folhas de cálculo nem termos complicados. Simples, em português, feito para quem está a começar.',
      subtitleTablet:
        'Organiza o teu dinheiro sem folhas de cálculo nem termos complicados. Simples, em português, feito para quem está a começar.',
      subtitleMobile:
        'Organiza o teu dinheiro sem folhas de cálculo nem termos complicados. Simples, em português, feito para quem está a começar.',
      cta: 'Começa grátis',
      device: {
        greeting: 'Olá, Marta',
        avatarInitial: 'M',
        cycleLabel: 'Ciclo atual',
        netWorthLabel: 'Património',
        netWorthValue: '24.380 €',
        remainingLabel: 'Ainda podes gastar',
        remainingValue: '342 €',
        savingsLabel: 'Poupança',
        savingsValue: '18%',
      },
    },
    riskBold: '3 meses sem pagar nada',
    riskRest: ' · sem cartão',
    riskBoldShort: '3 meses sem pagar nada',
    riskLine: '3 meses sem pagar nada · sem cartão',
    highlights: [
      {
        title: 'Ciclos, não meses',
        description: 'O teu mês financeiro começa quando recebes, não no dia 1.',
      },
      {
        title: 'Selfie financeira',
        description: 'Uma fotografia clara do que tens, do que deves e do que sobra.',
      },
      {
        title: 'Objetivos reais',
        description: 'Metas que fazem sentido para a tua vida, não para uma folha de cálculo.',
      },
    ],
    how: {
      tag: 'Como funciona',
      title: 'Três passos',
      steps: [
        {
          title: 'Selfie',
          description: 'Vês onde estás hoje, sem julgamentos.',
        },
        {
          title: 'Dinheiro',
          description: 'Organizas o que entra e o que sai em cada ciclo.',
        },
        {
          title: 'Evolução',
          description: 'Acompanhas o teu progresso mês a mês.',
        },
      ],
    },
    concept: {
      tag: 'Selfie financeira',
      title: 'Evolução do património',
      lead: 'Uma fotografia clara do que tens, do que deves e do que sobra, atualizada em cada ciclo.',
      bullets: ['O que tens', 'O que deves', 'O que sobra'],
      chartCaption: 'Evolução do património',
      chartPeriod: 'últimos 6 meses',
      chartValue: '24.380 €',
      chartDelta: '+18%',
      chartMonths: ['Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul'],
    },
    features: {
      tag: 'Funcionalidades',
      title: 'Orçamento, objetivos e fundo de emergência',
      items: [
        {
          title: 'Orçamento',
          description:
            'Divide o teu dinheiro por grupos e vê, sem contas, quanto ainda podes gastar.',
        },
        {
          title: 'Objetivos',
          description: 'Define metas com prazo e acompanha quanto falta em cada ciclo.',
        },
        {
          title: 'Fundo de emergência',
          description: 'Sabe quantos meses aguentas se a tua vida mudar amanhã.',
        },
      ],
      miniBudget: {
        title: 'Orçamento do ciclo',
        period: '1.600 € distribuídos',
        rows: [
          { label: 'Necessidades', amount: '720 €', trackPct: 72, tone: 'sage' },
          { label: 'Desejos', amount: '360 €', trackPct: 60, tone: 'want' },
          { label: 'Poupança', amount: '288 €', trackPct: 45, tone: 'save' },
        ],
      },
      miniGoal: {
        title: 'Objetivos',
        subtitle: '2 metas ativas',
        rows: [
          {
            label: 'Férias',
            saved: '620 €',
            target: '1.000 €',
            progress: 'faltam 4 ciclos',
            trackPct: 62,
          },
          {
            label: 'Casa nova',
            saved: '2.800 €',
            target: '10.000 €',
            progress: 'faltam 18 ciclos',
            trackPct: 28,
          },
        ],
      },
      miniFund: {
        title: 'Fundo de emergência',
        have: '3,2',
        ofMonths: 'meses de despesas cobertas',
        progress: 'Meta recomendada: 6 meses',
        trackPct: 53,
      },
    },
    fear: {
      tag: 'Sem medo',
      title: 'Não precisas de saber nada de finanças',
      cards: [
        {
          title: 'Sem jargão',
          description: 'Falamos português simples, não financês.',
        },
        {
          title: 'Ao teu ritmo',
          description: 'Começas pelo básico e avanças quando quiseres.',
        },
        {
          title: 'Explicamos tudo',
          description: 'Cada número vem com uma explicação em contexto.',
        },
      ],
    },
    finalCta: {
      title: 'Os teus primeiros três meses são por nossa conta',
    },
    footer: {
      faq: 'FAQ',
      contact: 'Contacto',
      copyright: '© 2026 EvPlanner',
      terms: 'Termos',
      privacy: 'Privacidade',
      about: 'Sobre',
    },
  },
  auth: {
    signIn: {
      title: 'Bem-vindo de volta',
      subtitle: 'Entra para continuares de onde ficaste.',
      submit: 'Entrar',
      submitting: 'A entrar…',
      noAccount: 'Ainda não tens conta?',
      goSignUp: 'Começa grátis',
      forgot: 'Esqueci-me da password',
      credentialsError: 'Email ou password incorretos.',
      credentialsErrorLead: 'Email ou password incorretos.',
      credentialsErrorBody: '',
      passwordResetSuccess: 'Password atualizada. Já podes entrar.',
    },
    forgotPassword: {
      title: 'Recuperar password',
      subtitle:
        'Indica o email da tua conta e enviamos-te um link para definires uma nova password.',
      submit: 'Enviar link',
      resubmit: 'Reenviar link',
      successTitle: 'Verifica o teu email',
      successSubtitle:
        'Se existir uma conta associada a esse email, enviámos um link para definires uma nova password. O link expira em 60 minutos, não te esqueças de ver o spam.',
      successBanner: 'Link enviado. Verifica o teu email.',
      success:
        'Se existir uma conta com esse email, vais receber instruções para redefinir a password.',
      backToSignIn: 'Voltar a entrar',
    },
    resetPassword: {
      title: 'Nova password',
      subtitle: 'Escolhe uma password segura para a tua conta.',
      submit: 'Guardar password',
      backToSignIn: 'Voltar a entrar',
      invalidLink: 'Este link de recuperação é inválido ou expirou.',
      invalidTitle: 'Link inválido',
      invalidSubtitle:
        'Por segurança, os links de redefinição expiram passados 60 minutos.',
      invalidBanner:
        'Este link expirou ou já foi usado. Pede um novo para continuares.',
      requestNewLink: 'Pedir novo link',
      strengthHint: 'Password forte: 8 caracteres ou mais.',
    },
    signUp: {
      title: 'Começa grátis',
      subtitle: 'Cria a tua conta e começa a organizar o teu dinheiro.',
      submit: 'Criar conta',
      submitting: 'A criar conta…',
      haveAccount: 'Já tens conta?',
      goSignIn: 'Entrar',
      termsPrefix: 'Aceito os ',
      termsLinkTerms: 'Termos',
      termsMiddle: ' e a ',
      termsLinkPrivacy: 'Política de Privacidade',
      termsSuffix: '.',
      riskLine: '3 meses grátis, sem cartão',
    },
    aside: {
      signUp: {
        headline: 'Organiza o teu dinheiro com calma.',
        sub: 'Planeamento por ciclos, não por meses. Vê para onde vai cada euro, cria o teu fundo de emergência e cresce o que fica.',
        benefits: [
          {
            icon: 'sparkle',
            title: 'Orçamento em minutos',
            body: 'Um assistente guia-te passo a passo.',
          },
          {
            icon: 'shield',
            title: 'Dados sempre seguros',
            body: 'Ligação encriptada e sessão protegida.',
          },
          {
            icon: 'clock',
            title: '3 meses grátis',
            body: 'Sem cartão. Cancelas quando quiseres.',
          },
        ],
      },
      signIn: {
        headline: 'Continua de onde ficaste.',
        sub: 'O teu ciclo, o teu património e os teus objetivos: tudo à espera, exatamente como deixaste. Entra e segue em frente.',
        benefits: [
          {
            icon: 'shield',
            title: 'Dados sempre seguros',
            body: 'Ligação encriptada e sessão protegida.',
          },
          {
            icon: 'clock',
            title: 'Retoma o teu progresso',
            body: 'Orçamentos e metas onde os deixaste.',
          },
        ],
      },
    },
    google: {
      continue: 'Continuar com Google',
      orDivider: 'ou com email',
    },
    nav: {
      signIn: 'Entrar',
      signUp: 'Registo',
      forgotPassword: 'Recuperar password',
    },
    fields: {
      email: 'Email',
      emailPlaceholder: 'o.teu@email.pt',
      password: 'Password',
      passwordNew: 'Nova password',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      passwordConfirm: 'Confirmar password',
      passwordConfirmPlaceholder: 'Repete a password',
      showPassword: 'Mostrar password',
      hidePassword: 'Ocultar password',
    },
    errors: {
      emailRequired: 'Indica o teu email.',
      emailInvalid: "Falta o '@'. Escreve algo como marta@email.pt",
      passwordRequired: 'Indica uma password.',
      passwordWeak: 'A password tem de ter pelo menos 8 caracteres, com letras e números.',
      passwordTooShort: 'Muito curta: usa pelo menos 8 caracteres.',
      passwordsDontMatch: 'As passwords não coincidem.',
      termsRequired: 'Tens de aceitar os termos.',
      generic: 'Não foi possível concluir. Tenta de novo.',
    },
  },
  cookies: {
    banner: {
      title: 'Cookies e privacidade',
      description:
        'Usamos cookies necessários para autenticação, segurança (CSRF) e preferências da conta. Podes aceitar cookies opcionais para estatísticas e marketing. Consulta a',
      privacyLink: 'Política de Privacidade',
      acceptAll: 'Aceitar todos',
      rejectOptional: 'Rejeitar não essenciais',
      customize: 'Personalizar',
      savePreferences: 'Guardar preferências',
      back: 'Voltar',
      necessaryTitle: 'Necessários',
      necessaryDesc: 'Sempre activos: sem estes cookies a app não funciona correctamente.',
      necessaryLabel: 'Autenticação, sessão segura e preferências essenciais',
      analyticsTitle: 'Analíticos',
      analyticsDesc: 'Ajudam-nos a perceber como a app é usada (ex.: páginas visitadas).',
      marketingTitle: 'Marketing',
      marketingDesc: 'Permitem medir campanhas e personalizar comunicações (quando activas).',
    },
  },
  onboarding: {
    progress: { stepLabel: 'Passo' },
    shellTitle: 'Vamos conhecer-te',
    rail: {
      title: 'Vamos preparar a tua conta.',
      subtitle:
        'Uns toques e a app já sabe como é a tua vida, sem escreveres quase nada.',
      duration: 'Demora cerca de 2 minutos.',
      navLabel: 'Passos do onboarding',
    },
    phases: {
      about: 'Sobre ti',
      life: 'A tua vida financeira',
      done: 'Pronto',
    },
    common: {
      continue: 'Continuar',
      back: 'Voltar',
      skipLater: 'Saltar, faço isto depois',
      skipAddLater: 'Saltar, adiciono depois',
      skipNoDebts: 'Não tenho dívidas, saltar',
    },
    welcome: {
      eyebrow: 'Bem-vindo',
      title: 'O teu mês, do teu jeito',
      subtitle:
        'Em menos de dois minutos pomos a app a saber como é a tua vida. Vamos por fases: sobre ti, a tua vida financeira, e pronto. Quase sem escrever nada.',
      concept:
        'Vamos só pôr o essencial de pé, e depois, com uns toques, deixamos a app já a saber como é a tua vida. Sem escrever quase nada.',
      cta: 'Vamos começar',
    },
    profile: {
      eyebrow: 'Sobre ti',
      title: 'Como te chamas?',
      subtitle: 'Para deixar a app com a tua cara. Podes usar só o primeiro nome.',
      fullNameLabel: 'O teu nome',
      fullNamePlaceholder: 'O teu nome',
      nameHint: 'Pré-preenchido a partir do teu registo, muda se quiseres.',
      nameError: 'Indica o teu nome.',
    },
    cycleDay: {
      eyebrow: 'Sobre ti',
      title: 'Que dia queres fechar o teu mês financeiro?',
      subtitle:
        'É o dia em que tiras a selfie e começas um novo ciclo. Se recebes ordenado ao dia 25, faz sentido fechar aí.',
      hint: 'Sugerido: dia 1. Podes mudar quando quiseres nas Definições.',
    },
    method: {
      eyebrow: 'Sobre ti',
      title: 'Como queres dividir o teu dinheiro?',
      subtitle:
        'Escolhe um método e, se quiseres, ajusta as percentagens até somarem 100%. Podes mudar mais tarde.',
      intro: {
        title: 'O teu método de orçamento',
        subtitle:
          'A maneira como divides o teu dinheiro define o ritmo da tua evolução. Vamos escolher um método juntos, podes sempre ajustar.',
        explainer:
          'Pensa nisto como dividir cada euro que entra em "bolsos" virtuais. Cada bolso tem um propósito.',
        cta: 'Ver métodos sugeridos',
      },
      preset: {
        title: 'Qual destes métodos faz mais sentido para ti?',
        subtitle: 'Escolhe o mais próximo e ajusta as percentagens se quiseres.',
        custom: 'Criar do zero',
        customDescription: 'Define os teus próprios grupos e percentagens.',
        cta: 'Continuar com este',
      },
      customise: {
        title: 'Ajusta as percentagens',
        subtitle:
          'Move os sliders até a soma dar 100%. Esta é a tua repartição mensal, podes mudar a qualquer momento.',
        total: 'Total',
        totalGood: 'Pronto! Soma 100%.',
        totalBad: 'A soma tem de ser exactamente 100%.',
        // CHANGE v2 §3: chaves aspirational removidas.
        submit: 'Continuar',
      },
    },
    incomeSources: {
      eyebrow: 'A tua vida financeira',
      title: 'De onde vem o teu dinheiro?',
      subtitle:
        'Toca nas que se aplicam. Ficam criadas em Rendimentos, depois é só registar valores.',
    },
    categories: {
      eyebrow: 'A tua vida financeira',
      title: 'Em que costumas gastar?',
      subtitle: 'Toca nas que fazem sentido. Ficam já criadas, depois é só usar.',
      intro: {
        title: 'Categorias para as tuas despesas',
        subtitle:
          'Categorias ajudam-te a perceber para onde vai o dinheiro. Vamos criar algumas em poucos segundos.',
        bulletA: 'Escolhes as que fazem sentido para ti.',
        bulletB: 'Sugerimos um grupo de orçamento para cada uma.',
        bulletC: 'Podes editar ou arquivar a qualquer momento.',
        cta: 'Vamos a isso',
      },
      // CHANGE v2 §4: cards verdes em vez de checkbox; review removido.
      select: {
        title: 'Que despesas costumas ter?',
        subtitle: 'Se quiseres podes escolher já algumas categorias que descrevem o teu mês. Vais poder criar ou ajustar à tua maneira mais à frente.',
        cta: 'Continuar',
        skip: 'Saltar, começar com lista vazia',
        chosenCount: '{n} escolhidas',
      },
    },
    // CHANGE v2 §26: copy "Contas" → "Ativos"; mantemos os exemplos
    // ("conta à ordem", "Conta Bancária") porque são tipos de ativo.
    accounts: {
      eyebrow: 'A tua vida financeira',
      title: 'Onde tens o teu dinheiro?',
      subtitle: 'Escolhe os tipos que tens. Não pedimos saldos agora, só quais existem.',
      selfieNote:
        'Isto prepara a tua primeira selfie: os saldos de cada um vêm a seguir, com calma.',
      intro: {
        badge: 'Ativos',
        title: 'Os teus ativos: onde está o teu dinheiro',
        subtitle:
          'Listamos os ativos (contas, poupanças, investimentos, imobiliário) que queres acompanhar. Não precisamos de credenciais bancárias; tu controlas tudo manualmente.',
        bulletA: 'Adiciona contas à ordem, poupança, corretora, cripto, imobiliário…',
        bulletB:
          'Uma vez por mês fazes uma "selfie": apontas os saldos e nós calculamos o teu Património.',
        bulletC:
          'Podes desactivar o que não queres incluir no Património ou marcar como fundo de emergência.',
        cta: 'Adicionar primeiro ativo',
      },
      first: {
        title: 'Adiciona pelo menos um ativo',
        subtitle:
          'Mesmo que comeces só com a conta à ordem, podes evoluir mês a mês. Vais sempre poder adicionar mais a seguir.',
        emptyHint: 'Ainda não tens ativos. Adiciona o primeiro para continuar.',
        addMore: 'Adicionar mais um',
        needAtLeastOne: 'Adiciona pelo menos um ativo antes de continuar.',
        cta: 'Continuar',
      },
    },
    debts: {
      eyebrow: 'A tua vida financeira',
      title: 'Tens alguma destas dívidas?',
      subtitle:
        'Se tiveres, mapeamos o caminho mais rápido para as pôr a zero. Se não, ótimo, salta.',
    },
    ready: {
      title: 'Está tudo pronto, {name}!',
      subtitle:
        'A app já sabe como é a tua vida, sem teres escrito quase nada. A partir daqui, é só usar.',
      pillSources: 'Fontes prontas',
      pillCategories: 'Categorias prontas',
      pillAssets: 'Ativos prontos',
      nextTitle: 'A seguir:',
      nextBody:
        'No Início tens o fluxo guiado à espera: primeiros passos com a selfie, o fundo de emergência e o resto, ao teu ritmo.',
      cta: 'Ir para o Início',
    },
    appearance: {
      badge: 'Aparência',
      title: 'Como preferes ver a app?',
      subtitle: 'Escolhe o tema claro, escuro ou automático. Podes mudar isto a qualquer momento nas definições.',
      cta: 'Continuar',
    },
    debtsCheck: {
      badge: 'Dívidas',
      title: 'Tens dívidas activas?',
      subtitle:
        'Créditos, cartões ou empréstimos em curso: ajudam-nos a personalizar os próximos passos.',
      body:
        'Se tiveres dívidas a pagar, mais tarde podes registá-las na secção Dívidas e acompanhar o plano de amortização. Se não tiveres, avançamos sem este passo no guia inicial.',
      yes: 'Sim, tenho dívidas activas',
      no: 'Não tenho dívidas activas',
    },
    selfie: {
      intro: {
        badge: 'Selfie',
        title: 'A tua selfie mensal',
        subtitle:
          'Uma vez por mês registas os saldos dos teus ativos. É a "fotografia" do teu Património: a base da tua evolução.',
        bulletA: 'Demoramos cerca de 1 minuto por mês.',
        bulletB: 'Podes copiar do mês anterior se nada mudou.',
        bulletC:
          'Lembramos-te no dia que escolheres, não te preocupas em não esquecer.',
        cta: 'Continuar',
      },
      first: {
        title: 'Primeira selfie: onde estás hoje',
        subtitle:
          'Indica o saldo actual de cada ativo. Vamos usar como referência inicial.',
      },
    },
  },
  // CHANGE v2 §6 + §13: novos blocos para income sources e ready no onboarding.
  onboardingIncomeSources: {
    intro: {
      badge: 'Rendimentos',
      title: 'De onde vem o teu dinheiro?',
      subtitle:
        'Escolhe as fontes de rendimento que se aplicam a ti. Podes editar mais tarde nas Definições.',
      bulletA:
        'Não precisas de indicar valores agora, só queremos os tipos de rendimento.',
      bulletB: 'Salário, freelancing, rendas, dividendos… o que quiseres.',
      cta: 'Continuar: escolher fontes',
    },
    select: {
      title: 'Tipos de rendimento',
      subtitle: 'Toca nas que se aplicam (podes escolher várias).',
      cta: 'Continuar',
      skip: 'Saltar este passo',
    },
  },
  onboardingReady: {
    badge: 'Quase a chegar',
    title: 'Estás pronto a começar!',
    subtitle:
      'O básico está configurado. Vamos guiar-te no resto sem pressas, passo a passo.',
    bulletA:
      'A partir daqui vais ver um plano guiado no início para evoluir ao teu ritmo.',
    bulletB:
      'No fim do mês recordamo-nos da tua primeira "selfie financeira": leva 1 minuto.',
    cta: 'Ir para o início',
  },
  expenses: {
    title: 'Despesas',
    subtitle: 'O que gastaste neste ciclo.',
    desktopCycleSub: 'Ciclo {period} · dia {day} de {total}',
    hero: {
      remainingLabel: 'Ainda podes gastar neste ciclo',
      cycleChip: 'Ciclo · {period}',
      manageCategories: 'Gerir categorias',
      spentPrefix: 'Gastaste',
      spentOf: 'de',
      daysLeftPrefix: 'faltam',
      daysLeftSuffix: 'dias',
      overBudgetLabel: 'Ultrapassaste o orçamento em {amount}',
      lowBudgetContext: 'Restam {days} dias neste ciclo, vai com calma.',
      limitAlertOne: '1 categoria acima do limite',
      limitAlertMany: '{count} categorias acima do limite',
      limitDetail: '{group} · acima {overBy} do limite de {budget}',
      noLimitAlert: 'Sem alertas de orçamento',
      savingsReserved: 'Reservado para poupança',
      savingsRate: 'Taxa de poupança',
      availablePct: '{pct}% disponível',
      daysLeft: 'restam {days} dias',
      dayLeft: 'resta 1 dia',
      // .pen `ds/card/cycle-spend-hero` › `foot`
      ofBudget: 'de {amount} orçamento',
    },
    sections: {
      byGroup: 'Onde está a ir',
      byGroupDesktop: 'Grupos do método',
      byGroupHint: 'grupos do método',
      byGroupTooltip:
        'Necessidades, Desejos e Poupança e Investimento: a forma como o teu método divide o rendimento.',
      cycleList: 'Movimentos do ciclo',
      cycleListHint: 'recentes primeiro',
    },
    tabs: {
      list: 'Despesas',
      byGroup: 'Despesas por grupo',
      tablistLabel: 'Vista das despesas',
    },
    byGroup: {
      empty: 'Ainda não há grupos de orçamento para mostrar.',
      noCategories: 'Sem categorias neste grupo.',
      reservedUnassigned: 'Reservado',
      unassigned: 'Não atribuído',
      reservedEmpty:
        'Define orçamentos nas categorias ou cofres no Orçamento.',
      pyfGroupLabel: 'Poupança e Investimento',
      // .pen `ds/card/expense-group--fechado|--aberto` › `error`
      loadError: 'Não foi possível carregar este grupo agora',
      groupOverBudgetOne: '1 categoria acima do orçamento neste grupo',
      groupOverBudgetMany: '{count} categorias acima do orçamento neste grupo',
      categoryOverBudget: 'Excedeu o orçamento em {amount} ({percent}% de {budget})',
    },
    distribution: {
      title: 'Distribuição por tipo',
      hint: 'essencial · desejo · poupança e investimento',
      tooltip:
        'Gastáveis pelo gasto do ciclo. Poupança e Investimento pelo valor reservado.',
      total: 'Total',
      empty: 'Sem dados neste ciclo.',
    },
    monitor: {
      title: 'Gastos do ciclo',
      subtitle: 'Quanto já gastaste face ao orçamento planeado.',
      planBudgetLink: 'Planear orçamento',
      groupsTablist: 'Grupos de orçamento',
      expandGroup: 'Ver detalhes de {name}',
    },
    readOnlyCycle:
      'Este período pertence a um ciclo já fechado. Só podes consultar: usa a seta para o ciclo seguinte para registar ou editar despesas (também em datas futuras desse ciclo).',
    cycle: {
      current: 'Ciclo actual',
      past: 'Ciclo anterior',
      prev: 'Ciclo anterior',
      next: 'Ciclo seguinte',
    },
    empty: {
      title: 'Ainda não tens despesas neste ciclo',
      subtitle: 'Regista a primeira despesa para veres onde o teu dinheiro está a ir.',
      cta: 'Registar primeira despesa',
      helperTitle: 'Como começar',
      helperItems: [
        'Usa «Nova despesa» ou o botão + no ecrã.',
        'Regista logo após pagar, fica mais fácil de lembrar.',
        'Não precisas de ser perfeito: o importante é criar o hábito.',
      ],
    },
    kpi: {
      total: 'Total de despesas',
      count: 'N.º de despesas',
      countHint: 'Registos no período',
      allInCycle: 'Todas no ciclo seleccionado',
    },
    filters: {
      toggle: 'Filtrar',
      toggleHide: 'Ocultar filtros',
      noResults: 'Nenhuma despesa com estes filtros.',
      month: 'Mês',
      all: 'Todos',
      category: 'Categoria',
      group: 'Grupo',
      essentiality: 'Tipo',
      essentialAll: 'Todos',
      essentialEssential: 'Essenciais',
      essentialNonEssential: 'Não essenciais',
      search: 'Procurar',
      searchPlaceholder: 'Descrição ou categoria…',
    },
    list: {
      today: 'Hoje',
      yesterday: 'Ontem',
      loadMore: 'Carregar mais',
      noMore: 'Não há mais despesas.',
      seeAllCycle: 'Ver todas as despesas do ciclo',
      // .pen `ds/card/record-day-group` › `error`
      loadError: 'Não foi possível carregar estes registos agora',
    },
    actions: {
      edit: 'Editar',
      delete: 'Apagar',
      deleteConfirmTitle: 'Apagar despesa?',
      deleteConfirmBody: 'Não dá para recuperar.',
      deleteConfirm: 'Apagar',
      deleted: 'Despesa apagada.',
      deleteError: 'Não foi possível apagar.',
      updated: 'Despesa actualizada.',
    },
    edit: {
      title: 'Editar despesa',
      submit: 'Guardar',
    },
    recurringToast: 'Registámos despesas recorrentes para hoje.',
  },
  categories: {
    title: 'Categorias',
    subtitle:
      'A estrutura das tuas despesas · os limites definem-se no Orçamento',
    addNew: 'Nova categoria',
    addFirst: 'Criar a primeira categoria',
    empty: {
      title: 'Ainda sem categorias',
      subtitle:
        'Uma categoria diz onde vai cada despesa. Escolhes o tipo e nós colocamo-la no grupo certo do método.',
    },
    scopeBanner: {
      beforeLink:
        'Arrasta um cartão para o balde certo: é assim que organizas. Os limites de gasto vives no',
      link: 'Orçamento',
      afterLink: '.',
    },
    buckets: {
      essential: 'Necessidades',
      lifestyle: 'Desejos',
      savings: 'Poupança',
      essentialSubtitle: 'o essencial',
      lifestyleSubtitle: 'o que gostas',
      savingsSubtitle: 'o teu futuro',
      noLimit: 'sem limite',
      addInBucket: 'Adicionar',
    },
    orphans: {
      title: '{n} por classificar',
      subtitle: 'Arrasta-as para um balde ou toca para escolher o tipo.',
      classify: 'Classificar',
      needsType: 'precisa de tipo',
      classifyTitle: 'Classificar categoria',
      classifyDescription: 'Que tipo é «{name}»? Vai para o balde certo do método.',
      classifySubmit: 'Classificar',
    },
    classification: {
      essential: 'Essencial',
      nonEssential: 'Não essencial',
      investment: 'Poupança e Investimento',
    },
    orphansBadge: 'Há {n} categoria(s) sem grupo válido',
    orphansFix: 'Resolver',
    archivedLabel: 'Arquivada',
    archivedHint: 'Não apaga o histórico, podes reactivar.',
    allArchivedHint: 'Todas as categorias estão arquivadas. Reactiva-as em baixo quando precisares.',
    archivedToast: '{name} arquivada.',
    restoredToast: '{name} reactivada.',
    reclassifiedToast: 'Categoria classificada.',
    reclassifyError: 'Não foi possível actualizar a categoria.',
    actions: {
      edit: 'Editar',
      archive: 'Arquivar',
      unarchive: 'Reactivar',
      reorder: 'Reordenar',
    },
    form: {
      titleCreate: 'Nova categoria',
      titleEdit: 'Editar categoria',
      createDescription:
        'Dá um nome e indica o tipo: o grupo no orçamento é atribuído automaticamente.',
      nameLabel: 'Nome',
      namePlaceholder: 'Mercearia, Combustível, …',
      colorLabel: 'Cor',
      noGroup: 'Sem grupo',
      allocationQuestion: 'Que tipo de despesa é esta?',
      allocationEssential: 'Essencial',
      allocationEssentialHint: 'Ex.: água, luz, renda, supermercado, transportes',
      allocationLifestyle: 'Prazer do dia a dia',
      allocationLifestyleHint: 'Ex.: restaurante, cinema, ginásio, subscrições de lazer',
      allocationInvestment: 'Investimento',
      allocationInvestmentHint: 'Ex.: curso, formação',
      frequencyLabel: 'Frequência',
      frequencyRegular: 'Regular',
      frequencyOccasional: 'Ocasional',
      submit: 'Guardar',
      budget: {
        sectionTitle: 'Orçamento mensal (opcional)',
        sectionHint:
          'Se definires um valor, avisamos-te quando te aproximares do limite, sem configuração extra.',
        defaultMonthlyLabel: 'Orçamento mensal (€)',
        defaultMonthlyPlaceholder: 'Ex.: 150',
        defaultMonthlyHelp: 'Deixa em branco se não quiseres limite nesta categoria.',
        thresholdWarningLabel: 'Aviso a partir de (%)',
        thresholdExceededLabel: 'Considerado excedido a (%)',
        thresholdHelp: 'Aviso tem de ser menor que excedido.',
        alertsEnabledLabel: 'Receber alertas no app',
      },
    },
  },
  budget: {
    title: 'Orçamento',
    eyebrow: 'Orçamento · o volante',
    subtitle:
      'Define quanto queres gastar em cada coisa e vê se o teu plano faz sentido face ao rendimento.',
    cycleTitle: 'Ciclo de {label}',
    firstCycleTitle: 'O teu 1º ciclo',
    methodBadge: 'Método {name}',
    spendCycleLink: 'Ver o que já gastei',
    allocationHero: {
      label: 'Já atribuíste',
      of: 'de',
      ofCycle: 'de {amount} do ciclo',
      percentLabel: 'com destino',
      savingsLabel: 'poupança',
      education:
        'Optimiza os gastos e aumenta a poupança. Os euros sem destino são a tua margem de manobra.',
      tooltip:
        'Soma dos limites que definiste por categoria face ao rendimento planeado deste ciclo: o valor que usas para distribuir o teu dinheiro.',
      unassigned: 'Poupança potencial',
      overAssigned: 'Acima do rendimento',
      pillRemaining: '{pct}% · {amount} poupáveis',
      pillComplete: 'Plano fechado: 100% com destino',
      pillOver: '{amount} acima do rendimento',
      hintRemaining:
        'Faltam {amount} por dar destino. Chega aos 100% para o plano ficar completo.',
      hintComplete: 'Plano completo: deste rendimento já tem destino definido.',
      hintOver:
        'O teu plano gasta mais do que ganhas ({amount} acima): ajusta os limites.',
      firstCycleReady: 'plano de partida pronto, afina se quiseres',
      // `.pen` → `ds/card/budget-allocation-hero` / `--excesso`.
      cycleChip: 'Ciclo · {period}',
      assignedPctLabel: '{pct}% atribuído',
      remainingToAssign: '{amount} por atribuir',
      overPlan: '{amount} acima do plano',
      viewExpensesLink: 'Ver despesas do ciclo',
      adjustExcessLink: 'Ajustar grupos com excesso',
    },
    cycle: {
      prev: 'Ciclo anterior',
      next: 'Ciclo seguinte',
    },
    groupRefs: {
      defined: 'Defini',
      limit: 'Limite {amount}',
      method: 'Método',
      methodAmount: 'Método {amount}',
      average: 'Média',
      averageAmount: 'Média {amount}',
      methodAndAverage: 'Método {method} · Média {average}',
      legendLimit: 'Limite',
      legendMethod: 'Método',
      legendAverage: 'Média real',
      target: 'Alvo {pct}%',
      targetFallback: 'Alvo',
      targetTooltip:
        'Quanto o teu método sugere para este grupo: por exemplo, 50% do rendimento planeado em Necessidades.',
      realAverage: 'Média real',
      realAverageNoHistory: 'Sem histórico',
      realAverageNoHistoryHint:
        'A média de gastos aparece após fechares mais ciclos. Até lá, usa o alvo do método como referência.',
      averageComing: 'média a chegar',
      targetPctAverageComing: 'alvo {pct}% · média a chegar',
    },
    // .pen `ds/card/budget-group` › `error`
    groupsLoadError: 'Não foi possível carregar os grupos agora',
    // .pen `ds/row/budget-group-item` › `r` › `p` (fatia do grupo)
    groupShare: '{pct} %',
    groupSubtitles: {
      needs: 'Casa, comida, contas',
      wants: 'Lazer, restaurantes, subscrições',
      savings: 'Fundo, objetivos, investir',
    },
    firstCycle: {
      banner:
        'Como é o teu primeiro ciclo, ainda não temos histórico. Começámos pelos alvos do teu método ({method}), ajusta à vontade. As sugestões vão ficar mais afinadas a cada ciclo.',
      acceptCta: 'Aceitar plano de partida',
      acceptedToast: 'Plano de partida aplicado.',
      acceptError: 'Não foi possível aplicar o plano de partida.',
    },
    category: {
      save: 'Guardar limite',
      fixedBudgetNote: 'Valor fixo · igual todos os ciclos',
      focusBack: 'Voltar ao grupo',
      focusGroupTitle: '{amount} em {count} categorias',
      otherInGroup: 'Outras deste grupo',
      averageCompact: 'média {amount}',
      ofGroup: 'de {amount} do grupo',
      suggestionAverage:
        'Gastaste em média {amount} aqui nos últimos ciclos.',
      suggestionShort:
        'Média {amount}: o teu limite pode ficar curto.',
      suggestionMethodTarget:
        'O alvo do método sugere {amount} para esta categoria',
      suggestionMethodNote:
        'As sugestões ficam mais precisas à medida que registas mais ciclos.',
      suggestionUse: 'Usar {amount}',
      suggestionUseWithBuffer: 'Usar {amount} (média + folga)',
    },
    planning: {
      budgetSumLabel: 'Soma dos orçamentos',
      savingsReserveNote:
        'Reservámos automaticamente {amount} ({pct}% do rendimento) para Poupança/Investimento. O orçamento por grupo abaixo usa apenas {pool}: o rendimento do ciclo menos essa reserva.',
      previousCycleBasisNote:
        'Os totais abaixo baseiam-se no rendimento do ciclo anterior até registares o deste ciclo.',
      historicalCycleNote:
        'Ciclo fechado: vês o teu plano actual e o que gastaste neste período.',
    },
    tabs: {
      method: 'Por método',
      categories: 'Por categoria',
    },
    monthLabel: '{month} de {year}',
    prevMonth: 'Mês anterior',
    nextMonth: 'Mês seguinte',
    monthNavHint: 'Ciclo atual e meses futuros. Meses anteriores não estão disponíveis.',
    noSnapshotMonths: {
      title: 'Orçamento após a primeira selfie',
      description:
        'O orçamento mensal fica disponível nos meses em que fizeres a selfie financeira. Faz a tua primeira selfie para começares.',
      cta: 'Fazer selfie',
    },
    cycleIncome: 'Rendimento planeado',
    cycleIncomeTooltip:
      'Valor usado para calcular os alvos do método e distribuir o teu plano. Pode vir do ciclo anterior, do ciclo actual ou de um valor manual.',
    previousCycleIncomeNote:
      'A planear com {amount} do ciclo anterior ({period}).',
    planningIncome: {
      editTitle: 'Rendimento de planeamento',
      editDescription:
        'Valor usado para calcular orçamento disponível e poupança potencial. Por defeito usa o ciclo anterior.',
      editCta: 'Editar',
      saved: 'Rendimento de planeamento actualizado.',
      defaultHint: 'Ciclo anterior ({period}).',
      chipsLabel: 'Sugestões de rendimento',
      chipPrevious: 'Rendimento anterior',
      chipCurrent: 'Rendimento atual',
    },
    currentCycleIncomeNote:
      'A planear com {amount} registados neste ciclo.',
    manualCycleIncomeNote:
      'Valor manual de planeamento, não altera os rendimentos registados.',
    historicalCycleIncomeNote:
      'Rendimento registado neste ciclo ({period}).',
    historicalCycleIncomeMissing:
      'Sem rendimento registado neste ciclo fechado.',
    useCurrentCycleIncome: 'Rendimentos deste ciclo',
    usePreviousCycleIncome: 'Rendimentos do ciclo anterior',
    useManualIncome: 'Valor manual',
    manualIncomeLabel: 'Rendimento de planeamento (€)',
    manualIncomePlaceholder: 'Ex.: 2500',
    manualIncomeSave: 'Aplicar valor',
    manualIncomeSaved: 'Rendimento de planeamento actualizado.',
    manualIncomeInvalid: 'Indica um valor positivo em euros.',
    planningIncomeSaveError: 'Não foi possível guardar o rendimento de planeamento.',
    planningIncomeEmpty: 'Sem rendimento de planeamento: regista rendimentos em',
    planningIncomeEmptySuffix: ' ou define um valor manual com Editar.',
    registerIncomeRequired:
      'Regista o rendimento deste ciclo para planear o orçamento com valores reais em',
    totals: {
      budget: 'Orçamento',
      totalAllocated: 'Total alocado',
      totalAvailable: 'Total disponível',
      spent: 'Gasto',
      cycleMargin: 'Margem do ciclo',
      realSavingsRate: 'Taxa de poupança real',
      remaining: 'Disponível',
      overBudget: 'Excedido',
      projected: 'Projeção',
      noBudget: 'Sem orçamento',
    },
    potentialSavings: {
      title: 'Potencial taxa de poupança',
      formula: 'Disponível nas despesas + reserva automática Poupança/Investimento',
      available: 'Disponível',
      methodSlice: 'Alocação Poupança/Investimento',
      alreadyInPots: 'Já em cofres (despesa)',
    },
    status: {
      ok: 'No bom caminho',
      reserved: 'Poupança / invest.',
      exceeded: 'Acima do orçamento',
      no_budget: 'Sem orçamento',
    },
    savingsEstimate: {
      title: 'Estimativa de poupança',
      income: 'Rendimento',
      planned: 'Despesas planeadas',
      margin: 'Margem',
      savingsRate: '{pct}% poupança',
    },
    incomeMetricsPending:
      'Regista rendimentos no ciclo actual para veres a estimativa de poupança.',
    method: {
      label: 'Método',
      title: 'Por grupos do método',
      empty: 'Ainda não criaste um método de orçamento.',
      cta: 'Criar método',
      changeMethod: 'Alterar método',
      changeTitle: 'Método de orçamento',
      changeDescription:
        'Define a percentagem de cada grupo. A fatia de poupança/investimento é alocada automaticamente no orçamento.',
      editCurrent: 'Ajustar actual',
      choosePreset: 'Escolher modelo',
      changeSuccess: 'Método actualizado.',
      changeError: 'Não foi possível actualizar o método.',
      totalLabel: 'Total: {total}% (tem de ser 100%)',
      adjustPercentages: 'Ajusta as percentagens',
      totalCheckLabel: 'Total (tem de ser 100%)',
      fixedAllocation: 'Alocação fixa',
      fixedAllocationHint:
        'Valor calculado automaticamente a partir do rendimento do ciclo e da percentagem do método.',
      smoothingPots: 'Cofres de suavização',
      groupedHint:
        'Regista rendimentos no ciclo actual para veres orçamento, disponível e alvos do método.',
      explainerTitle: 'O método divide o rendimento por grupos',
      explainerDescription:
        'Escolhe um modelo (50/30/20, zero-based) ou define as tuas percentagens. Podes mudar sempre que quiseres.',
      groupTarget: 'Alvo {pct}%',
      groupActual: 'Real {pct}%',
      groupBudgetAllocation: 'Alocado / Disponível',
      groupCategoryAllocation: 'Alocado nas categorias / Alvo',
      groupSpendVsBudget: 'Gasto / Orçamento',
      groupSpendVsAvailable: 'Gasto / Disponível',
      groupReservedVsTarget: 'Reservado / Alvo',
      groupReservedBreakdown:
        '{detail} em categorias e cofres (abaixo) · {unassigned} reservado pelo método (ainda sem linha nomeada).',
      groupReservedDetailOnly:
        '{detail} em categorias e cofres: o envelope do método está todo nomeado.',
      groupReservedUnassignedOnly:
        '{unassigned} reservados pelo método: define orçamentos nas categorias ou cofres abaixo.',
      groupReservedEmptyHint:
        '{target} reservados pelo método (30% do rendimento). Ainda não há categorias nem cofres com orçamento neste grupo.',
    },
    categories: {
      title: 'Por categoria',
      empty: 'Não há categorias com orçamento ou despesas neste mês.',
      newExpenseCategory: 'Nova categoria de despesa',
      newExpenseCategoryGroupHint: 'Orçamentada no grupo «{group}»',
      newExpenseCategoryEmptyHint:
        'Ainda não há categorias de despesa aqui: por exemplo supermercado ou ginásio.',
      formCreateDescription:
        'Para registar despesas como supermercado ou ginásio, orçamentada no grupo «{group}».',
      formCreateDescriptionGeneric:
        'Para registar e planear despesas, escolhe depois a classificação no método.',
      addToGroup: 'Adicionar categoria a {group}',
      adjustCta: 'Ajustar orçamento',
      detailCta: 'Ver detalhe',
      sparkline: 'Últimos 12 meses',
      sortBy: 'Ordenar por',
      sortDefault: 'Maior gasto',
      sortPct: 'Maior % do orçamento',
    },
    drilldown: {
      backLink: 'Voltar ao orçamento',
      historyTitle: 'Histórico 12 meses',
      expensesTitle: 'Despesas do mês',
      noExpenses: 'Sem despesas este mês.',
    },
    columns: {
      category: 'Categoria',
      budget: 'Orçamento',
      allocated: 'Alocado',
      spent: 'Gasto',
    },
    adjust: {
      titleFor: 'Orçamento para {category}',
      titleFallback: 'Orçamento',
      subtitle: 'Valor mensal do teu plano.',
      amountLabel: 'Valor mensal (€)',
      save: 'Guardar',
      saved: 'Orçamento actualizado.',
      saveError: 'Não foi possível guardar o orçamento.',
    },
  },
  alerts: {
    empty: 'Sem alertas este mês.',
    dismiss: 'Dispensar',
  },
  quickExpense: {
    title: 'Nova despesa',
    subtitle: 'Valor, categoria e está feito.',
    amountLabel: 'Valor',
    amountPlaceholder: '0,00',
    categoryLabel: 'Categoria',
    newCategory: 'Nova categoria',
    categoryCreatedToast: 'Categoria criada.',
    pickCategory: 'Escolhe uma categoria',
    dateLabel: 'Data',
    descriptionLabel: 'Descrição (opcional)',
    descriptionPlaceholder: 'Ex: almoço com cliente',
    more: 'Mais opções',
    less: 'Esconder opções',
    submit: 'Guardar',
    successToast: 'Despesa registada',
    noCategoriesYet: 'Cria uma categoria primeiro.',
    goToCategories: 'Ir para categorias',
    // CHANGE v2 §30.3: secção dedicada para depositar num cofre.
    potDepositTitle: 'Ou deposita num cofre',
    potDepositExpand: 'Depositar num cofre?',
    potDepositCollapse: 'Esconder depósito em cofre',
    potDepositLabel: 'Cofre',
    potDepositSubmit: 'Depositar no cofre',
    potDepositDirectTitle: 'Depositar no cofre',
    potDepositDirectSubtitle: 'Escolhe o valor, podes fazer vários depósitos no mesmo mês.',
    potDepositAmountLabel: 'Quanto vais depositar?',
    potDepositHintsTitle: 'Dicas de depósito',
    potDepositRemainingCell: 'Falta juntar',
    potDepositSuggestedCell: 'Sugestão mensal',
    potDepositContributedCell: 'Já neste ciclo',
    potDepositAfterCell: 'Depois deste depósito',
    potDepositAmountHint: 'Sugestão para este mês: {amount} €',
    potDepositRemaining: 'Em falta no cofre: {amount} €',
    potDepositCycleContributed: 'Já depositado neste ciclo: {amount} €',
    potDepositAfter: 'Depois deste depósito: {amount} € em falta',
    potDepositOverRemaining: 'Não pode ultrapassar o que falta ({amount} €).',
    potDepositFillMonthly: 'Valor mensal',
    potDepositFillRemaining: 'Quitar em falta',
    showMoreCategories: 'Ver mais categorias',
    categoriesModalTitle: 'Mais categorias',
    categoriesModalDescription: 'Escolhe a categoria para esta despesa.',
  },
  dashboard: {
    zones: {
      cycle: 'Ciclo',
      nextStep: 'Próximo passo',
      netWorth: 'O teu património',
      cycleSummary: 'Como vai o ciclo',
      report: 'Relatório',
      expenses: 'As tuas despesas',
    },
    cycleCard: {
      title: 'Ciclo atual',
      titleWithDays: 'Ciclo atual · faltam {days} dias',
      titleWithOneDay: 'Ciclo atual · falta 1 dia',
      titleClosingToday: 'Ciclo atual · fecha hoje',
      daysLabel: 'dias',
      dayLabel: 'dia',
      readoutDays: 'faltam {days} dias',
      readoutOneDay: 'falta 1 dia',
      readoutToday: 'fecha hoje',
      readoutOverdue: 'está por fechar',
    },
    greeting: {
      weekdayDate: '{weekday}, {date}',
      withCycle: '{weekday}, {date} · Ciclo {period}',
      dayOfCycle: 'Estás no dia {day} do ciclo · {period}',
    },
    cycleSummary: {
      remaining: 'Ainda podes gastar',
      remainingLong: 'Ainda podes gastar neste ciclo',
      ofBudget: 'de {amount} neste ciclo',
      pctAvailable: '{pct}% disponível',
      daysLeft: 'faltam {days} dias',
      dayLeft: 'falta 1 dia',
      savingsRate: 'Taxa de poupança',
      savingsRateShort: 'Poupança',
      savingsRateCycle: 'Taxa de poupança neste ciclo',
      savingsRateTooltip:
        'Quanto do que ganhas neste ciclo conseguiste poupar: rendimento menos despesas (incluindo cofres).',
      spendableTooltip:
        'O que sobra depois de rendimento menos despesas fixas, cofres e o que já gastaste',
      spendRate: '≈ {rate}/dia até fechar',
    },
    netWorthHero: {
      label: 'Património líquido',
      vsMonth: 'face a {month}',
      chartFrom: 'desde {month}',
      chartWindowChange: '{amount} no período',
      emptyHint: 'Regista a tua primeira selfie para veres o património aqui.',
      emptyCta: 'Fazer selfie financeira',
      emptyDescription: 'Vais ver aqui o teu património e a evolução mês a mês.',
      emptyLinkCta: 'Fazer a primeira selfie',
      emptyChartLabel: 'Sem histórico ainda',
      // .pen `ds/card/networth-hero--empty` › `empty-title`
      emptyTitle: 'Sem património ainda',
    },
    goalFocus: {
      eyebrow: 'Objetivo prioritário',
      readout: 'faltam {amount}',
      scaleLeft: '{accumulated} de {target}',
      toneDone: 'concluído',
      toneOnTrack: 'a caminho',
      toneBehind: 'atrasado',
      toneUrgent: 'urgente',
    },
    annualAgenda: {
      eyebrow: 'Pagamentos anuais',
      sub: '{count} pagamentos anuais até {month}',
      subOne: '1 pagamento anual até {month}',
      relativeMonth: 'daqui a 1 mês',
      relativeMonths: 'daqui a {count} meses',
      footLeft: 'Próximo daqui a {days} dias',
      footLeftTomorrow: 'Próximo amanhã',
      footLeftToday: 'Próximo hoje',
    },
    selfieCadence: {
      eyebrow: 'Selfie financeira',
      sub: 'último retrato do teu património',
      scaleRight: '{count} de {total} meses registados',
      footLink: 'Ver relatório de {month}',
      emptyReadout: '—',
      emptySub: 'ainda sem relatório',
      emptyCta: 'Tirar a primeira selfie',
    },
    expenseRecent: {
      eyebrow: 'Últimas despesas',
      link: 'Ver todas',
      footLeft: 'soma destas {count}',
      today: 'Hoje',
    },
    empty: {
      title: 'Ainda não há nada para mostrar',
      subtitle:
        'À medida que registas despesas e defines objetivos, o início ganha vida.',
    },
    nextStepsTitle: 'Próximos passos',
    nextSteps: {
      expense: {
        title: 'Regista a tua primeira despesa',
        subtitle: 'Para começar a ver o que entra e sai.',
      },
      account: {
        title: 'Adiciona um ativo',
        subtitle: 'Mantém o saldo real à mão.',
      },
      goal: {
        title: 'Cria o teu primeiro objetivo',
        subtitle: 'Planeia uma evolução com propósito.',
      },
    },
    // CHANGE v2 §12: fluxo guiado pós-onboarding (G1..G4).
    guidedFlow: {
      panelBadge: 'Início dos passos',
      heroBadge: 'A tua base financeira',
      heroProgressLabel: '{done} de {total}',
      heroProgressHint: '{done} de {total} passos feitos · falta pouco',
      nextStepLabel: 'Próximo passo',
      continueButton: 'Continuar',
      viewJourneyLink: 'Ver a jornada toda',
      dismissLabel: 'Esconder este cartão',
      doneStepLabel: '1 passo feito',
      doneStepsLabel: '{count} passos feitos',
      journeyTitle: 'A tua jornada',
      journeyHeadline: 'Monta a tua base financeira',
      youAreHere: 'Estás aqui',
      doneTag: 'Feito',
      startStepButton: 'Começar',
      alreadyDoneButton: 'Já está',
      title: 'Próximos passos para ficares no controlo',
      subtitle: 'Passos curtos para configurares a tua base financeira.',
      progressLabel: '{done} de {total} passos concluídos',
      moreStepsPending: '+{count} passos por concluir',
      startButton: 'Começar agora',
      resumeButton: 'Resumir o progresso',
      modalTitle: 'Configuração inicial',
      stepLabel: 'Passo {current} de {total}',
      skipButton: 'Saltar',
      skippedBadge: 'saltado',
      doneButton: 'Já está feito',
      celebration: {
        title: 'Tens a tua base financeira montada!',
        body:
          'Configuraste tudo: selfie, rendimento, despesas, fundo e o teu primeiro objetivo. Já não és novato, o EvPlanner é teu.',
        stepsStat: 'passos',
        cta: 'Entrar no meu Início',
      },
      steps: {
        g1_selfie_day: {
          title: 'Escolhe o dia da selfie',
          subtitle: 'O dia em que fechas o teu mês financeiro: a âncora de todo o ciclo.',
          cta: 'Continuar',
        },
        g2_first_selfie: {
          title: 'Faz a tua primeira selfie',
          subtitle: 'Uma fotografia do que tens hoje. É o ponto de partida de tudo.',
          cta: 'Fazer selfie',
          ctaPath: '/app/selfie/new',
        },
        g10_first_income: {
          title: 'Regista o teu rendimento',
          subtitle: 'O que entra. Separamos o fixo do variável para não contares a mais.',
          cta: 'Registar rendimento',
          ctaPath: '/app/income?register=1',
          doneHint:
            'Assim que tiveres pelo menos um rendimento registado, este passo conclui-se sozinho.',
        },
        g3_first_expenses: {
          title: 'As tuas 3 maiores despesas',
          subtitle: 'Onde vai a maior fatia. Ver isto é meio caminho para controlares.',
          contextTip:
            'Tenta registar todas as despesas que conseguires este mês. Precisas de 3 para concluir este passo.',
          progressLabel: '{count} de {required} despesas registadas',
          cta: 'Registar despesa',
          ctaPath: '/app/expenses',
          doneHint: 'Com 3 despesas registadas, este passo conclui-se sozinho.',
        },
        g11_active_debts: {
          title: 'Tens dívidas?',
          subtitle:
            'Mapeamos o que deves para traçar o caminho mais rápido para zero.',
          cta: 'Ir para Dívidas',
          ctaPath: '/app/dividas',
          doneHint:
            'Se não tens dívidas, salta. Se registaste pelo menos uma, o passo conclui-se sozinho.',
        },
        g4_emergency_fund: {
          title: 'Cria o teu fundo de emergência',
          subtitle: 'A rede de segurança para os imprevistos não te tirarem do plano.',
          cta: 'Configurar fundo',
          ctaPath: '/app/emergency-fund/wizard',
          cardTitle: 'Fundo de Emergência',
          cardBody:
            'Dinheiro guardado para imprevistos, para um susto não te desequilibrar. Leva poucos minutos a definir a tua meta.',
          doneHint:
            'Quando concluíres o assistente de configuração, este passo conclui-se sozinho.',
        },
        g5_category_budgets: {
          title: 'Define os teus orçamentos',
          subtitle: 'Um limite por categoria: o método a funcionar no dia-a-dia.',
          cta: 'Definir orçamentos',
          ctaPath: '/app/budget',
          doneHint:
            'Com pelo menos um orçamento definido, este passo conclui-se sozinho.',
        },
        g6_occasional_calendar: {
          title: 'Calendário de despesas ocasionais',
          subtitle: 'IUC, seguros anuais e outros pagamentos previsíveis.',
          cta: 'Configurar calendário',
          ctaPath: '/app/calendar',
        },
        g7_first_smoothing_pot: {
          title: 'Cria o teu primeiro cofre',
          subtitle:
            'Um cofre por despesa ocasional ajuda-te a poupar ao longo do ano até ao mês do pagamento.',
          cta: 'Ver cofres',
          ctaPath: '/app/pots',
          pickHint: 'Escolhe uma despesa ocasional e cria o cofre com um clique:',
          itemMeta: '{month} · {category}',
          createPotCta: 'Criar cofre',
          noOccasionalsHint:
            'Ainda não tens despesas ocasionais no calendário. Volta ao passo anterior ou abre o calendário para adicionar a primeira.',
          allHavePotsHint:
            'Ao registares despesas ocasionais, o cofre de suavização é criado automaticamente. Podes avançar.',
          doneHint:
            'Com pelo menos um cofre (ou sem ocasionais), este passo conclui-se sozinho.',
        },
        g8_first_goal: {
          title: 'O teu primeiro objetivo',
          subtitle: 'Uma meta clara e com prazo para o dinheiro ter para onde ir.',
          cta: 'Criar objectivo',
          ctaPath: '/app/goals/new',
        },
      },
      // CHANGE v2 §10: setup do dia do mês antes da primeira selfie.
      selfieDay: {
        label: 'Em que dia do mês queres fazer a tua selfie?',
        help:
          'Vamos lembrar-te neste dia para fechares o mês. Podes mudar depois nas definições.',
        salaryTip:
          'Normalmente o novo mês começa mais ou menos no dia que recebes o salário.',
        daySuffix: 'do mês',
        savedToast: 'Dia da selfie actualizado.',
      },
      selfieWaiting: {
        body:
          'A tua selfie fica disponível no dia {day} do mês. Enquanto esperas, podes avançar nos passos seguintes.',
        cycleBody:
          'A selfie fica disponível a partir de {date} (fim do ciclo actual). Enquanto esperas, podes avançar nos passos seguintes.',
      },
      categoryBudgets: {
        lead: 'Um orçamento mensal por categoria ajuda-te a manter o controlo.',
        benefits: [
          'Vês logo quando estás a aproximar-te do limite, antes de ultrapassar.',
          'Recebes avisos discretos no registo rápido de despesas.',
          'Comparas o planeado com o real no ecrã de Orçamento.',
        ],
        continueLater: 'Continuar sem orçamentos por agora',
      },
    },
    // CHANGE v2 §15: Widget IA do Dashboard.
    visionWidget: {
      badge: 'Sugestão para ti',
      refresh: 'Actualizar sugestão',
    },
    totalThisMonth: 'Total deste mês',
    vsLastMonth: 'vs mês anterior',
    suggestions: {
      sectionTitle: 'Sugestões',
      sectionHint:
        'Acções recomendadas para melhorares o teu plano financeiro.',
      types: {
        occasional_pot: {
          badge: 'Cofre',
          message: 'Cria um cofre de suavização para ires poupando até ao mês previsto.',
          itemMeta: '{month} · {category}',
          cta: 'Criar cofre',
        },
        debt_repayment_plan: {
          badge: 'Dívidas',
          title: 'Plano de amortização',
          message:
            'Tens {count} dívida(s) activa(s) sem plano. Gera um plano para priorizar pagamentos e poupar juros.',
          cta: 'Gerar plano',
        },
      },
    },
    alerts: {
      sectionTitle: 'Alertas',
      hint: '· {count} a precisar da tua atenção',
      more: '+{count} alertas · ver todos',
      severityDanger: 'Críticos',
      severityWarning: 'Avisos',
      severityInfo: 'Info',
      types: {
        missing_budgets_summary: {
          badge: 'Configurar',
          title: '{count} categorias sem orçamento',
          message: 'Define limites mensais nas categorias para acompanhares os gastos.',
        },
        category_budget_exceeded_summary: {
          badge: 'Excedido',
          title: '{count} categorias acima do orçamento',
          message: 'Vê onde o gasto ultrapassou o orçamento definido.',
        },
        method_allocation_over: {
          badge: 'Método',
          title: 'Rendimento demasiado alocado em {group}',
          message:
            'Os orçamentos das categorias neste grupo somam mais do que o alvo do método ({target}%). Revê a distribuição do teu rendimento.',
        },
      },
    },
    cycleClose: {
      dueToday: {
        title: 'O teu ciclo fecha hoje',
        message: '{period} · tira a selfie para começar o próximo',
        messageFallback: 'Tira a selfie para começar o próximo ciclo.',
        cta: 'Tirar selfie financeira',
      },
      overdue: {
        title: 'O teu ciclo está por fechar',
        message: '{period} · tira a selfie para começar o próximo',
        messageFallback: 'Tira a selfie para começar o próximo ciclo.',
        cta: 'Tirar selfie financeira',
      },
    },
    charts: {
      distributionTitle: 'Distribuição de despesas',
      distributionTabsLabel: 'Vista do gráfico',
      tabByCategory: 'Por categoria',
      tabByEssentiality: 'Essencial / não essencial',
      periodSelfie: 'Ciclo actual: {range}',
      essentialLabel: 'Essenciais',
      nonEssentialLabel: 'Não essenciais',
      investmentLabel: 'Investimento',
      allocationTabsLabel: 'Tipo de despesa',
      totalExpenses: 'Total de despesas',
      emptyPeriod: 'Sem despesas neste período.',
      noGroupLabel: 'Sem grupo',
      latest: 'Últimas despesas',
      seeAll: 'Ver todas as despesas',
      incomeEvolutionTitle: 'Evolução do rendimento',
      incomeEvolutionSubtitle: 'Total registado em cada ciclo da selfie.',
      expenseEvolutionTitle: 'Evolução das despesas',
      expenseEvolutionSubtitle: 'Total gasto nos ciclos já fechados.',
      expenseEvolutionAvgLabel: 'média mensal',
      expenseEvolutionLabel: 'Despesas',
      expenseEvolutionEmpty:
        'Ainda não há despesas nos ciclos recentes. Quando registares, vês a evolução aqui.',
      expenseEvolutionEmptyNoCycles:
        'Fecha a primeira selfie para começares a ver ciclos.',
    },
    annualUpcoming: 'Próximos pagamentos anuais',
    monthAbbr: {
      1: 'Jan',
      2: 'Fev',
      3: 'Mar',
      4: 'Abr',
      5: 'Mai',
      6: 'Jun',
      7: 'Jul',
      8: 'Ago',
      9: 'Set',
      10: 'Out',
      11: 'Nov',
      12: 'Dez',
    },
  },
  // CHANGE v2 §26: secção "Contas" passa a ser "Ativos" no UI. Os nomes
  // técnicos das categorias (ex: "Conta Bancária") mantêm-se porque
  // designam tipos de ativo, não a área da app.
  accounts: {
    title: 'Ativos',
    subtitle: 'Onde está o teu dinheiro: os sítios e o tipo, não o quanto (isso é o Património).',
    assetTermTooltip:
      'Um ativo é um sítio onde tens dinheiro: conta, investimento, cripto ou outro. Aqui defines a lista; na selfie actualizas os saldos.',
    addNew: 'Novo ativo',
    selfieNote:
      'Estes são os sítios que vais atualizar na tua selfie mensal: é o que alimenta a tua evolução de património.',
    listSection: 'Os teus ativos',
    listSectionSubtitle: '· onde tens o teu dinheiro',
    displayGroups: {
      banking: 'Contas bancárias',
      investments: 'Investimentos',
      crypto: 'Cripto',
      other: 'Outros',
    },
    liquidity: {
      available: 'Parado',
      invested: 'Investido',
      availableHint: 'Contas e dinheiro: usas quando quiseres',
      investedHint: 'Preciso de tempo ou custo para usar',
      availableTooltip:
        'Dinheiro que podes usar de imediato: contas à ordem e numerário. Ter €X não é o mesmo que poder usar €X.',
      investedTooltip:
        'Dinheiro a trabalhar: leva tempo ou tem custo a mobilizar (investimentos, cripto, imóveis, etc.).',
      toggleLabel: 'Este dinheiro está…',
      toggleTooltip:
        'Indica se consegues usar este dinheiro de imediato ou se precisa de tempo/custo para mobilizar.',
      horizonLabel: 'Liquidez',
      horizonSubtitle: 'Tempo até chegares a cada parte',
      horizonTooltip:
        'Tempo estimado para conseguires aceder a este dinheiro, desde o momento em que decides vender ou retirar.',
      horizonFootFast: '{pct}% acessível em 2 dias',
      horizonFootSlow: '{pct}% preso a anos',
      // .pen `ds/chart/donut · liquidez` › `foot` (label + valor separados)
      horizonFootFastLabel: 'Acessível em 2 dias',
      horizonFootSlowLabel: 'Preso a anos',
      noHorizonData: 'Ainda não há saldos para mostrar a liquidez.',
      horizons: {
        immediate: 'Imediato',
        days_1_2: '1–2 dias',
        days_2_5: '2–5 dias',
        weeks: 'Semanas',
        months: 'Meses',
        years_plus: 'Anos+',
      },
    },
    summaryCard: {
      totalLabel: 'Total em ativos',
      totalTooltip:
        'Soma dos saldos dos teus ativos activos na última selfie concluída, convertidos para EUR. Um ativo é um sítio onde tens dinheiro: a selfie actualiza quanto há em cada um.',
      emergencyFundNote:
        'O teu fundo de emergência vive no disponível já: cobre {months} meses.',
      noBalance: '—',
    },
    archiveConfirm: 'Tens a certeza que queres arquivar "{name}"?',
    allArchivedHint: 'Todos os ativos estão arquivados. Reactiva um ou cria um novo.',
    empty: {
      title: 'Sem ativos por agora',
      subtitle:
        'Os ativos são a base de tudo: sem eles não há selfie mensal nem evolução de património. Adiciona o primeiro sítio onde tens dinheiro.',
      cta: 'Adicionar o primeiro ativo',
    },
    categories: {
      cash: 'Liquidez',
      bank_account: 'Conta Bancária',
      savings_account: 'Conta Poupança',
      brokerage: 'Corretora',
      crypto: 'Cripto',
      real_estate: 'Imobiliário',
      precious_metal: 'Metais Preciosos',
      vehicle: 'Veículo',
      business: 'Negócio',
      other: 'Outro',
    },
    // CHANGE v2 §8: notInNetWorth removido — todas as contas activas entram no Património.
    badges: {
      emergencyFund: 'Fundo de emergência',
      archived: 'Arquivado',
    },
    actions: {
      edit: 'Editar',
      archive: 'Arquivar',
      restore: 'Reactivar',
    },
    toasts: {
      created: 'Ativo criado.',
      updated: 'Ativo actualizado.',
      archived: '{name} arquivado.',
      restored: '{name} reactivado.',
      archiveFailed: 'Não foi possível arquivar o ativo.',
      restoreFailed: 'Não foi possível reactivar o ativo.',
    },
    summary: {
      activeCountLabel: 'Ativos activos',
      activeCountOne: '1 ativo activo',
      activeCountMany: '{count} ativos activos',
      activeCountHint: 'Contas e activos que acompanhas nas selfies financeiras.',
      categoriesLabel: 'Tipos de ativo',
      categoriesHint: 'Categorias diferentes com ativos activos.',
      emergencyFundLabel: 'No fundo de emergência',
      emergencyFundHint: 'Ativos marcados como parte do colchão financeiro.',
      countOne: '1 ativo',
      countMany: '{count} ativos',
      metaLabel: 'Detalhes',
    },
    errors: {
      nameRequired: 'Indica um nome para o ativo.',
      liquidityRequired: 'Indica onde está este dinheiro.',
      currencyLettersOnly: 'Usa apenas letras, sem vírgulas nem espaços (ex.: EUR ou BTC).',
      currencyUnsupported:
        'Moeda não reconhecida. Exemplos: EUR, USD, GBP, CHF, JPY, BTC, ETH, USDT.',
      tickerLettersOnly:
        'Usa apenas letras do par de moedas (ex.: BTCEUR, ETHEUR), sem ações nem outros símbolos.',
    },
    form: {
      titleCreate: 'Novo ativo',
      titleEdit: 'Editar ativo',
      helper:
        'Escolhe a categoria que melhor descreve este ativo. Os campos abaixo ajustam-se conforme escolheres.',
      typeLabel: 'Tipo',
      typeLabels: {
        conta: 'Conta',
        corretora: 'Corretora',
        crypto: 'Cripto',
        ouro: 'Ouro',
        imobiliario: 'Imobiliário',
        outro: 'Outro',
      },
      balanceLabel: 'Saldo',
      balancePlaceholder: '0',
      balanceHelp:
        'O saldo definitivo confirma-se na selfie mensal, aqui é só uma referência ao criar o sítio.',
      submitCreate: 'Guardar ativo',
      moreOptions: 'Mais opções',
      categoryLabel: 'Categoria',
      nameLabel: 'Nome',
      namePlaceholder: 'Ex.: Conta à ordem, Bitcoin, Casa…',
      // CHANGE v2 §8: institution/include_in_net_worth/is_emergency_fund_part/is_active removidos do form.
      currencyLabel: 'Moeda do ativo',
      currencyHelp:
        'Em que moeda está este ativo (ex.: EUR, USD, BTC). Apenas letras, sem vírgulas nem espaços.',
      currencyHelpCrypto:
        'Moeda do activo cripto (ex.: BTC, ETH). Na selfie vais indicar a quantidade nesta moeda.',
      tickerLabel: 'Par de moedas (conversão para EUR)',
      tickerHelp:
        'Par cambial na exchange para obter o valor em EUR (ex.: BTCEUR, ETHEUR, USDTEUR). Não uses tickers de ações.',
      tickerPlaceholder: 'BTCEUR',
      acquisitionDateLabel: 'Data de aquisição',
      acquisitionValueLabel: 'Valor de aquisição (EUR)',
      notesLabel: 'Notas',
      submit: 'Guardar',
    },
  },
  snapshots: {
    title: 'Selfie do mês',
    cycleEdit: {
      title: 'Ajustar ciclo actual',
      description:
        'Define desde que dia queres ver despesas e rendimentos neste ciclo. Não pode incluir datas em que já fizeste selfie.',
      startLabel: 'Início do ciclo',
      defaultHint: 'Início automático após a última selfie: {date}',
      reset: 'Repor automático',
      success: 'Ciclo actual actualizado.',
      resetSuccess: 'Ciclo reposto para o período automático.',
      error: 'Não foi possível actualizar o ciclo.',
    },
    new: {
      headerLabel: 'Selfie',
      title: 'Fechar ciclo financeiro',
      periodLabel: 'Período: {period}',
      cycleStartDateLabel: 'Início do ciclo',
      cycleStartDateHint: 'Desde quando contas despesas e rendimentos neste ciclo.',
      cycleCloseDateLabel: 'Data de fecho do ciclo',
      cycleCloseDateHint: 'Normalmente é hoje: o dia em que fechas este período.',
      cycleDatesInvalid: 'A data de início tem de ser anterior ou igual à data de fecho.',
      availableFrom: 'Disponível a partir de {date}.',
      unavailableTitle: 'Ainda não podes fechar o ciclo',
      unavailableDescription:
        'A selfie fica disponível a partir do fim do período actual ({date}). Até lá, continua a registar despesas e rendimentos.',
      backToPatrimonio: 'Voltar ao Património',
      errorToast: 'Não foi possível registar a selfie.',
      progress: '{filled} de {total} ativos preenchidos',
      copyPrevious: 'Igual ao mês anterior',
      empty: 'Não tens ativos activos. Adiciona um primeiro.',
      submit: 'Confirmar selfie',
      successToast: 'Selfie registada: Património actualizado.',
      missingHint:
        'Falta preencher pelo menos um ativo. Podes copiar o mês anterior se nada mudou.',
      pricePerUnitLabel: 'Valor estimado em EUR',
      goToAccounts: 'Adicionar ativo primeiro',
      liabilitiesSection: 'Dívidas',
      liabilitiesProgress: '{filled} de {total} dívidas preenchidas',
      liabilityBalanceLabel: 'Saldo em dívida (EUR)',
      amountPaidLabel: 'Pago este mês (opcional)',
      interestPaidLabel: 'Juros pagos este mês (opcional)',
      copyPreviousLiability: 'Igual ao mês anterior',
    },
    terms: {
      financialSelfie: {
        label: 'Selfie financeira',
        body:
          'Um retrato do teu dinheiro num momento: saldos de contas, investimentos e dívidas. Alimenta o Património e o Relatório IA.',
      },
      closeCycle: {
        label: 'Fechar o ciclo',
        body:
          'Quando confirmas a selfie, fechas o período actual de despesas e rendimentos e abrimos automaticamente o ciclo seguinte.',
      },
    },
    ritual: {
      wizardTitle: 'Selfie de {month}',
      stepLabel: 'Selfie de {month} · {current} de {total}',
      moment: {
        eyebrow: 'Fim de ciclo',
        title: 'Vamos tirar a tua selfie de {month}',
        help:
          'Um momento só teu para ver como está o teu dinheiro. Sem pressa, sem julgamento: só tu e a tua evolução.',
        firstEyebrow: 'A tua primeira selfie',
        firstTitle: 'O ponto de partida da tua jornada',
        firstHelp:
          'Uma selfie é uma fotografia do que tens hoje. Esta é a primeira: o marco zero a partir do qual vais ver tudo crescer. Respira, e vamos com calma.',
        list1: 'Actualizas os saldos (já vêm preenchidos)',
        list2: 'Vês a tua evolução do mês',
        list3Before: 'Fechas o ciclo',
        list3After: ' e abres o próximo',
        cta: 'Vamos a isto',
        ctaFirst: 'Começar a minha primeira selfie',
        adjustDates: 'Ajustar datas do ciclo',
        statAssets: 'ativos',
        statDebts: 'dívidas',
        statTime: 'tempo',
        // .pen `Selfie · Ritual · Momento` › `nota` (cartão de contexto sob os stats)
        noteTitleFirst: 'Não é um teste',
        noteBodyFirst:
          'Só te pedimos o saldo de cada conta e de cada dívida. Não há valores certos nem errados, há o teu ponto de partida.',
        noteTitle: 'O que acontece a seguir',
        noteBody:
          'Atualizas os saldos, vês o teu património revelado e fechamos o ciclo de {month}. O próximo abre sozinho.',
      },
      balances: {
        liveLabel: 'Património agora',
        liveDelta: '{delta} face a {month}',
        liveVsMonth: 'vs {month}',
        liveFlat: 'sem alterações',
        eyebrow: 'Actualiza só o que mudou',
        beforeLabel: 'anterior: {amount}',
        unchanged: 'sem mudança',
        resetPrevious: 'Igual ao mês anterior',
        liabilitiesEyebrow: 'Dívidas',
        cta: 'Continuar',
        firstSelfieHint:
          'Preenche os saldos de hoje: na próxima selfie já vêm pré-preenchidos.',
      },
      assets: {
        title: 'O que tens hoje?',
        subtitle:
          'Já pusemos os saldos do mês anterior. Só mexes no que mudou, o resto fica igual.',
        subtitleFirst:
          'Preenche os saldos de hoje: na próxima selfie já vêm pré-preenchidos.',
      },
      debts: {
        title: 'E o que ainda deves?',
        subtitle:
          'O mesmo aqui: atualiza só o que pagaste ou mudou. Cada euro a menos conta.',
        emptyTitle: 'Ainda não tens dívidas activas',
        emptyBody: 'Podes continuar: o património líquido = o que tens.',
      },
      confirm: {
        title: 'Antes de revelar…',
        subtitle: 'Dá uma última olhada. Se estiver tudo certo, revelamos o teu património.',
        assetsLabel: 'Total em ativos',
        debtsLabel: 'Total em dívidas',
        netLabel: 'Património líquido',
        cta: 'Revelar o meu património',
        ctaEdit: 'Guardar alterações',
        // .pen `Selfie · Ritual · Confirmação · datas` › `data-selfie` label
        snapshotDateLabel: 'Data da selfie',
      },
      revelation: {
        cheer: 'Selfie de {month}',
        fromTo: 'O teu património passou de {from} para {to}',
        // .pen `Selfie · Revelação · primeira` › `marco` (título estático; o valor é o `valor` grande separado)
        firstMarker: 'O teu marco zero',
        firstTitle: 'O teu marco zero: {amount}',
        firstBody:
          'A partir daqui, tudo é evolução. Da próxima vez vais ver este número mexer-se, e vais saber porquê.',
        firstBadge: 'ponto de partida',
        upBody: 'Subiste {amount} este ciclo. Isto é o teu esforço a dar frutos, parabéns.',
        downBody:
          'Desceu {amount}, e não faz mal. Meses assim acontecem; o que importa é veres e perceberes. Já vamos ajudar-te.',
        flatBody: 'Estável este ciclo. Manteres-te firme já é meio caminho andado.',
        chartRange: '{start} → hoje · {count} selfies',
        totalGain: '{amount} no total',
        streakTitle: '{count} meses seguidos a subir',
        streakSubtitle: 'É este hábito que constrói o teu património',
        downAmount: '{amount} este mês',
        downNote:
          'Este mês desceu {amount}, faz parte do percurso. O relatório explica o que pesou, sem drama.',
        reportTitle: 'Ler a análise da IA',
        reportTitleDown: 'Ler a análise da IA',
        reportSubtitle: 'O que mudou e o que fazer a seguir',
        reportSubtitleDown: 'O que mudou e o que fazer a seguir',
        // .pen `ds/wizard/footer` › `next` em todas as variantes de Revelação
        closeCycle: 'Fechar o ciclo',
        closeCycleMonth: 'Fechar o ciclo de {month}',
      },
    },
    result: {
      title: 'A tua evolução',
      vsPrevious: 'vs mês anterior',
      topMoversTitle: 'Maiores variações por ativo',
      noPrevious: 'Sem snapshot anterior para comparar.',
      cta: 'Ver Património completo',
      ctaDashboard: 'Ir para o início',
      viewReport: 'Ver relatório de fecho',
      closeCycle: 'Fechar o ciclo de {month}',
    },
    report: {
      title: 'Relatório de fecho',
      eyebrow: 'Selfie financeira',
      comparesWith: 'Compara com {period}',
      takenOn: 'Tirada em {date}',
      selfieNumber: 'Selfie #{n}',
      sections: {
        patrimonio: 'Património',
        timeline: 'Evolução recente',
        allocation: 'Onde está o teu dinheiro',
        assets: 'Ativos',
        liabilities: 'Passivos',
        method: 'Orçamento do ciclo',
        categories: 'Categorias: orçamento vs gasto',
        cycleFinance: 'Resumo financeiro do ciclo',
        topExpenses: 'Maiores despesas do ciclo',
        assessment: 'O que correu bem, o que não correu, o que pode melhorar',
        categoryOrganization: 'Organização das categorias',
        categoryOrganizationNoteTitle: 'Como estás a organizar as categorias',
        good: 'Correu bem',
        bad: 'Precisa de atenção',
        improve: 'Pode melhorar',
        goals: 'Os teus objectivos',
        nextSteps: 'Próximos passos sugeridos',
        charts: 'Despesas e evolução',
      },
      charts: {
        patrimonioLine: 'Evolução do património',
        expensesByGroup: 'Distribuição por grupo',
        expensesByGroupHint: 'Quanto gastaste em cada grupo do método neste ciclo.',
        expensesByCategory: 'Distribuição por categoria',
        expensesByCategoryHint: 'As categorias com mais peso no total de despesas.',
        expensesByDay: 'Despesas por dia do ciclo',
        expensesByDayHint:
          'Registaste despesas em {days} de {total} dias, vê onde se concentraram.',
        peakDaysTitle: 'Dias com mais gasto',
        empty: 'Sem despesas registadas neste ciclo.',
        totalSpent: 'Total gasto',
        distributionTitle: 'Distribuição das despesas',
        tabByGroup: 'Por grupo',
        tabByCategory: 'Por categoria',
        distributionTabsLabel: 'Agrupar despesas',
        sectionIntro:
          'Como se distribuíram as despesas neste ciclo e como evoluiu o teu património.',
      },
      allocationIntro: 'Variação dos teus ativos e passivos face à selfie anterior.',
      methodIntro:
        'Método ativo: {method}. Rendimento líquido do ciclo: {income}. Valores abaixo = orçamento alocado a cada grupo.',
      method: {
        targetLabel: 'alvo',
        cycleLabel: 'Ciclo',
        incomeFootnote: 'Rendimento do ciclo: {amount}',
      },
      metrics: {
        assets: 'Ativos totais',
        liabilities: 'Dívidas totais',
        savingsRate: 'Taxa de poupança',
        cycleIncome: 'Rendimentos do ciclo',
        cycleExpenses: 'Despesas do ciclo',
        cycleMargin: 'Margem (poupaste)',
        vsPrevious: 'vs período anterior',
      },
      cycleFinanceIntro:
        'Quanto entrou, quanto saiu e quanto ficou disponível neste ciclo fechado.',
      table: {
        asset: 'Ativo',
        previous: 'Anterior',
        current: 'Actual',
        change: 'Variação',
        category: 'Categoria',
        budget: 'Orçamento',
        spent: 'Gasto',
        status: 'Estado',
        target: 'Alvo',
        actual: 'Real',
        group: 'Grupo',
      },
      footer: 'Relatório gerado automaticamente · EvPlanner',
      back: 'Voltar ao histórico',
      print: 'Imprimir / guardar PDF',
      generating: 'O relatório do teu mês está a ser gerado…',
      generatingHint: 'Normalmente demora alguns segundos.',
      slowGeneration: 'Está a demorar mais do que o normal…',
      checkNow: 'Verificar agora',
      failed: 'Não foi possível gerar a avaliação automática.',
      failedHint: 'As secções numéricas estão disponíveis.',
      regenerate: 'Regenerar relatório',
      consultantVerdict: {
        eyebrow: 'Veredito do consultor',
      },
      layers: {
        consultantName: 'O teu consultor',
        highlights: 'Os 3 destaques do mês',
        nextSteps: 'Próximos passos',
        nextStepsFor: 'Próximos passos · para {period}',
        details: 'Os números completos',
        tapToExpand: 'Toca para ver',
      },
      verdictPill: {
        good: 'Bom mês',
        mixed: 'Mês misto',
        attention: 'Atenção',
      },
      highlights: {
        best: 'O melhor',
        attention: 'A atenção',
        improve: 'O que melhorar',
      },
      meta: {
        patrimonio: 'Património',
        savings: 'Poupança',
        streak: 'Streak',
        selfies: 'Selfies',
        streakUnit: '{n} meses',
        selfiesUnit: '{n}',
      },
      generation: {
        title: 'A analisar o teu mês',
        compareWith: 'A comparar com {period}',
        steps: {
          balances: 'Li os teus novos saldos',
          evolution: 'Calculei a tua evolução',
          categories: 'A olhar para as tuas categorias',
          summary: 'A escrever o teu resumo',
        },
      },
      nextSteps: {
        go: 'Ir',
      },
      modules: {
        patrimonio: 'Património',
        orcamento: 'Orçamento',
        objetivos: 'Objectivos',
        emergencyFund: 'Fundo de Emergência',
        despesas: 'Despesas',
        rendimentos: 'Rendimentos',
        cofres: 'Cofres',
        dividas: 'Dívidas',
      },
      disclaimer: {
        default:
          'Escrito pelo assistente do EvPlanner a partir dos teus dados. É orientação, não aconselhamento financeiro profissional.',
        cautious:
          'Um mau mês faz parte do percurso. O importante é o padrão ao longo do tempo, e o teu continua a construir-se.',
      },
      pageTitle: 'Relatório de {period}',
      mobileTitle: 'Relatório IA',
      share: 'Partilhar',
      dashboardCard: 'Relatório de {period} disponível',
      dashboardCardHint: 'A tua avaliação personalizada do ciclo está pronta.',
      categoryTipIntro:
        'Algumas categorias podem estar no grupo errado do teu método de orçamento.',
      editCategory: 'Editar categorias',
    },
    // CHANGE v2 §11: copy para histórico e edição de selfies passadas.
    history: {
      title: 'Selfie Financeira',
      subtitle: 'A tua jornada mês a mês: cada selfie alimenta o Património e o Relatório IA.',
      journeyEyebrow: 'A tua jornada',
      journeyCountOne: '· 1 selfie',
      journeyCountMany: '· {count} selfies',
      sparklineLabel: 'Património a cada selfie',
      sparklineLatest: 'última selfie',
      invite: {
        // .pen: pk3I7 (--overdue) / onErA (--due) / aLDdy (--upcoming)
        overdueTitle: 'A tua selfie de {month} está em atraso',
        dueTitle: 'Está na hora da tua selfie de {month}',
        dueSubtitle: 'O ciclo fechou {when} · demora 2 min',
        dueToday: 'hoje',
        overdue: 'ontem',
        upcoming: 'Próxima selfie a {date}',
        upcomingSubtitleOne: 'Ainda falta 1 dia para fechares o ciclo',
        upcomingSubtitleMany: 'Ainda faltam {days} dias para fechares o ciclo',
      },
      portrait: {
        baseline: 'ponto de partida',
        openReport: 'Ver relatório',
      },
      empty: {
        title: 'A tua primeira selfie é o ponto de partida',
        subtitle:
          'Uma selfie financeira é um retrato do teu dinheiro num momento. A partir daqui, vais ver a tua evolução mês a mês. A linha a subir é a prova de que estás a construir algo.',
        note:
          'Só precisas de actualizar os saldos dos teus ativos hoje. Nós tratamos do resto: o gráfico começa a ganhar forma já na próxima.',
        cta: 'Tirar a minha primeira selfie',
      },
      editLabel: 'Editar',
      reportLabel: 'Ver relatório de fecho',
      deleteLabel: 'Apagar',
      deleteConfirmTitle: 'Apagar selfie?',
      deleteConfirmBody:
        'Queres apagar a selfie de {month}? Esta acção não pode ser desfeita.',
      deleteError: 'Não foi possível apagar a selfie.',
      monthYearFormat: '{month} de {year}',
    },
    // CHANGE v2 §14.6: modal pós-selfie para confirmar/saltar contribuições mensais.
    monthlyCheck: {
      title: 'Contribuições mensais por confirmar',
      subtitle:
        'Para os teus cofres com objectivos activos: já contribuíste este mês?',
      expectedLabel: 'Esperado',
      contributedLabel: 'Já contribuído',
      confirm: 'Sim, contribuí o esperado',
      skip: 'Saltar, recalcular esforço',
      finish: 'Concluído',
      empty: 'Nenhum cofre precisa de confirmação. 🎉',
      confirmedToast: 'Contribuição registada.',
      skippedToast: 'Saltado, esforço mensal recalculado.',
    },
    edit: {
      // .pen: nU8QY "Editar selfie de {month}" (topbar) / "Corrigir saldos de {month}" (passo Ativos)
      wizardTitle: 'Editar selfie de {month}',
      title: 'Corrigir saldos de {month}',
      subtitle:
        'Correcção de uma selfie passada: os totais serão recalculados automaticamente.',
      // .pen: pbg46/k14wzN (Selfie · Edição · Dívidas · 375 light/dark) › copy
      debtsTitle: 'Corrigir dívidas de {month}',
      debtsSubtitle:
        'Ajusta o que devias no fim de {month}: o património líquido é recalculado ao guardares.',
      // .pen: OVQ8Q (Selfie · Edição · Confirmação) › copy
      confirmTitle: 'Antes de guardar…',
      confirmSubtitle:
        'Confirma os totais da selfie de {month}. Se estiver tudo certo, guardamos as alterações.',
      adjustDate: 'Ajustar data da selfie',
      // .pen: nU8QY/OVQ8Q step-indicator phase label ("PASSO N DE 3 · <fase>")
      stepLabels: { assets: 'Ativos', debts: 'Dívidas', confirm: 'Confirmação' },
      notesLabel: 'Notas',
      dateLabel: 'Data da selfie',
      accountsTitle: 'Saldos por ativo',
      balanceLabel: 'Saldo nesta data',
      saveLabel: 'Guardar alterações',
      savedToast: 'Selfie actualizada, Património recalculado.',
      deleteLabel: 'Apagar selfie',
      back: 'Voltar ao histórico',
    },
  },
  // CHANGE v2 §7: Net Worth → Património.
  patrimonio: {
    title: 'Património',
    subtitle: 'A tua evolução mês a mês.',
    desktopSubtitle: '{value} · {delta} desde a última selfie',
    desktopSubtitleValueOnly: '{value}',
    viewReports: 'Ver relatórios',
    empty: {
      title: 'Ainda não há Património registado',
      subtitle: 'Faz a tua primeira selfie para começares.',
      cta: 'Fazer a primeira selfie',
    },
    hero: {
      label: 'O teu património',
      vsPrevious: 'vs mês anterior',
      sinceLastSelfie: 'desde a última selfie ({date})',
      firstSelfie: 'A tua 1ª selfie · {date}',
      declineNote:
        'Este mês desceu, faz parte do percurso. Toca num ponto do gráfico para veres porquê.',
      tooltip:
        'Património = Ativos − Dívidas. É o resultado directo dos teus comportamentos financeiros mês a mês.',
    },
    streak: {
      growingOne: '1 mês consecutivo a crescer',
      growingMany: '{count} meses consecutivos a crescer',
    },
    journey: {
      title: 'A tua evolução',
      hint: 'toca num ponto',
      selfieNote: 'Cada ponto é uma selfie financeira',
      selfieTooltip:
        'Selfie financeira: o retrato mensal dos teus saldos. Cada ponto no gráfico é uma selfie.',
      empty: 'Sem dados de evolução ainda.',
      anticipation: {
        title: 'A tua evolução começa já no próximo mês',
        body:
          'Cada selfie financeira acrescenta um ponto ao gráfico. Com a 2ª vais ver a tua primeira linha, e daí em diante, a tua história a crescer.',
        nextInDays: 'Próxima selfie em {days} dias',
        nextInOneDay: 'Próxima selfie amanhã',
        cta: 'Tirar a próxima selfie',
      },
    },
    formula: {
      title: 'De que é feito',
      have: 'Tens',
      owe: 'Deves',
      netWorth: 'Património',
      haveTooltip:
        'Ativos, tudo o que tens com valor monetário: contas, investimentos, poupanças e outros bens.',
      oweTooltip:
        'Passivos, as tuas dívidas em aberto: créditos, cartões, empréstimos e outras obrigações.',
      netWorthTooltip: 'Património líquido = Ativos − Dívidas. Simples assim.',
    },
    composition: {
      title: 'Composição',
      assets: 'Ativos',
      debts: 'Dívidas',
      manageDetail: 'Gerir em detalhe',
      assetsTooltip: 'Onde está o teu dinheiro hoje, agrupado por tipo de ativo.',
      debtsTooltip: 'O que ainda deves: cada linha é uma dívida activa registada.',
      emptyAssets: 'Ainda não há ativos com saldo na última selfie.',
      // .pen `ds/card/composition-group` › `error`
      loadError: 'Não foi possível carregar este grupo agora',
      // .pen `ds/row/composition-item` › `r` › `p`
      pctOfAssets: '{pct}% dos ativos',
      buckets: {
        daily: 'Conta à ordem',
        investments: 'Investimentos',
        savings: 'Poupança / cofres',
      },
    },
    detailLinks: {
      assets: 'Ativos',
      debts: 'Dívidas',
    },
    chartTitle: 'Evolução do Património',
    breakdownTitle: 'Distribuição por ativo',
    tableTitle: 'Detalhe por ativo',
    newSelfie: 'Nova selfie',
    assetsLabel: 'Ativos',
    liabilitiesLabel: 'Dívidas',
    liabilitiesTableTitle: 'Passivos (dívidas)',
    table: {
      account: 'Ativo',
      latestBalance: 'Saldo actual',
      previousBalance: 'Saldo anterior',
      change: 'Variação',
      liability: 'Dívida',
    },
  },
  liabilities: {
    title: 'Dívidas',
    subtitle: 'O teu caminho para ficares livre, com calma e um plano.',
    totalDebts: 'Total em dívida',
    summary: {
      totalHint: 'Soma dos saldos em dívida das contas activas.',
      monthlyPaymentsLabel: 'Prestações mensais',
      monthlyPaymentsHint:
        'Total equivalente mensal de todas as prestações registadas.',
      priorityDebtLabel: 'Prioridade para liquidar',
      priorityDebtHint: 'Saldo das dívidas classificadas como menos boas.',
      activeCountLabel: 'Dívidas activas',
    },
    addDebt: 'Nova dívida',
    listTitle: 'As tuas dívidas',
    attackFirst: 'A atacar primeiro',
    toPay: 'a pagar',
    perMonth: '/mês',
    interestLabel: 'juro',
    sections: {
      priority: 'Prioridade para liquidar',
      betterProfile: 'Com melhor perfil',
    },
    liberty: {
      freeLabel: 'livre',
      statusWithProgress: 'Estás a {pct}% de ficares livre',
      statusZero: 'Vamos traçar o caminho',
      paidAndRemaining: 'Já pagaste {paid} · faltam {remaining}',
      freeEta: 'No ritmo atual, livre em {date}',
    },
    planLink: {
      title: 'O teu plano de pagamento',
      noPlan: 'Escolhe como queres atacar as dívidas',
      withMethod: '{method} · livre em {date}',
      withMethodNoDate: '{method}',
    },
    terms: {
      effortRate: {
        label: 'Taxa de esforço',
        body: 'A fatia do teu rendimento mensal que vai para prestações de dívidas. Abaixo de 30% costuma ser folgado; acima de 40% começa a apertar.',
      },
      interest: {
        label: 'Juros',
        body: 'O custo extra que pagas por pedires dinheiro emprestado. Quanto mais depressa liquidares, menos juros pagas no total.',
      },
      amortization: {
        label: 'Amortização',
        body: 'Pagares mais do que a prestação mínima para reduzir o saldo mais depressa, e ficares livre mais cedo.',
      },
    },
    empty: {
      title: 'Não tens dívidas registadas.',
      subtitle:
        'Se tiveres algum crédito (cartão, automóvel, pessoal), podes acompanhá-lo aqui e traçar um plano calmo para o liquidares.',
      cta: 'Registar uma dívida',
    },
    classification: {
      good: 'Boa',
      bad: 'Menos boa',
    },
    purpose: {
      necessity: 'Necessidade',
      desire: 'Desejo',
      investment: 'Investimento',
    },
    purposeHints: {
      necessity: 'Essencial (ex.: saúde, habitação urgente)',
      desire: 'Opcional (ex.: viagens, gadgets)',
      investment: 'Gera retorno (ex.: formação, negócio)',
    },
    investmentReturnType: {
      monetary: 'Monetário',
      education: 'Formação / Conhecimento',
      other: 'Outro',
    },
    investmentReturnTypeHints: {
      monetary: 'Retorno medido em percentagem anual',
      education: 'Capacitação, cursos, certificações',
      other: 'Outro benefício não monetário',
    },
    types: {
      mortgage: 'Crédito Habitação',
      auto: 'Crédito Automóvel',
      consumer: 'Crédito ao Consumo',
      credit_card: 'Cartão de Crédito',
      student: 'Crédito Estudantil',
      business: 'Negócio',
      personal_loan: 'Empréstimo Pessoal',
      other: 'Outro',
    },
    form: {
      titleCreate: 'Nova dívida',
      titleEdit: 'Editar dívida',
      subtitle: 'Indica o tipo, o fim da dívida e o que pagas hoje. A classificação (boa/má) é automática.',
      nameLabel: 'Nome',
      namePlaceholder: 'Ex.: Crédito habitação, Cartão X…',
      typeLabel: 'Tipo de dívida',
      purposeLabel: 'Para que fim é esta dívida?',
      classificationAuto: 'Classificação automática: {value}',
      investmentReturnTypeLabel: 'Tipo de retorno esperado',
      expectedReturnLabel: 'Retorno anual estimado (%)',
      expectedReturnOptional: 'Opcional, só usado para comparar com a TAEG.',
      investmentReturnTypeRequired: 'Seleciona o tipo de retorno esperado.',
      debtAmountLabel: 'Valor em dívida (EUR)',
      taegLabel: 'TAEG (%)',
      taegHint:
        'Taxa Anual Efetiva Global: referência legal para comparar créditos (inclui custos).',
      losingMoneyWarning:
        'O retorno estimado é igual ou inferior à TAEG: o custo da dívida supera o retorno esperado. Será classificada como má.',
      paymentAmountLabel: 'Valor da prestação (EUR)',
      paymentRecurrenceLabel: 'Recorrência',
      paymentRecurrence: {
        monthly: 'Mensal',
        quarterly: 'Trimestral',
        semi_annual: 'Semestral',
        annual: 'Anual',
      },
      creditorLabel: 'Credor (opcional)',
      remainingMonthsLabel: 'Meses restantes',
      notesLabel: 'Notas',
      submit: 'Guardar',
    },
    plan: {
      title: 'Plano de libertação',
      subtitle: 'Há duas boas maneiras de atacar as tuas dívidas. Não há errada, escolhe a que te mantém motivado.',
      intro:
        'Há duas boas maneiras de atacar as tuas dívidas. Não há errada, escolhe a que te mantém motivado.',
      avalanche: 'Pagar menos juros no total',
      snowball: 'Sentir vitórias mais cedo',
      freeIn: 'Livre em',
      totalInterest: 'Juros totais',
      firstVictory: '1ª vitória',
      priority: 'Ordem',
      balance: 'Saldo',
      rate: 'Taxa',
      payment: 'Prestação',
      payoffMonths: 'Meses até liquidar',
      interestRemaining: 'Juros restantes',
      empty: 'Adiciona dívidas activas para ver o plano.',
      save: 'Guardar este plano',
      saved: 'Plano guardado.',
    },
    evaluator: {
      title: 'Nova dívida?',
      subtitle: 'Antes de te comprometeres, vê como esta dívida encaixa no teu orçamento.',
      typeLabel: 'Do que se trata?',
      amountLabel: 'Valor a pedir (EUR)',
      rateLabel: 'Taxa anual (%)',
      paymentLabel: 'Prestação mensal',
      paymentSuffix: '€ /mês',
      termLabel: 'Prazo (meses)',
      incomeLabel: 'Rendimento mensal (se a app não tiver o teu)',
      submit: 'Ver como encaixa',
      verdict: {
        go: 'Cabe folgado',
        caution: 'Aperta um pouco',
        avoid: 'É arriscado',
        comfortable: 'Cabe folgado',
        tight: 'Aperta um pouco',
        risky: 'É arriscado',
      },
      effortFromTo: 'passaria de {from}% para {to}%',
      effortWhy:
        'A tua taxa de esforço (a fatia do rendimento que vai para dívidas) {change}. {bandHint}',
      bandHint: {
        comfortable: 'Estás dentro do saudável: há folga para imprevistos.',
        tight: 'Dá para fazer, mas ficarias com menos folga para imprevistos.',
        risky: 'Acima de 40% costuma apertar. Vale a pena rever o valor ou o prazo.',
      },
      tipLowerPayment:
        'Uma prestação de {suggested} em vez de {proposed} manteria a tua taxa de esforço nos {rate}%, dentro do saudável.',
      missingIncome:
        'Indica o teu rendimento mensal para calcularmos a taxa de esforço.',
      reasonsTitle: 'Análise',
      tipsTitle: 'Sugestões',
    },
    simulator: {
      title: 'Simulador',
      question: 'E se pagasses mais por mês?',
      extraLabel: 'Extra mensal',
      perMonth: '/mês',
      modeOneTime: 'Pagamento único',
      modeMonthly: 'Extra mensal',
      submit: 'Simular',
      monthsSaved: 'ficas livre mais cedo',
      monthsSavedValue: '−{n} meses',
      interestSaved: 'poupas em juros',
      baseline: 'Plano actual',
      accelerated: 'Com extra',
      rewardLine:
        'Com {newPayment}/mês em vez de {basePayment}, liquidas em {date}, e sobra-te esse dinheiro para os teus objetivos.',
      requiresData: 'Indica a prestação mensal na ficha da dívida para simular.',
    },
    actions: {
      plan: 'Ver plano',
      evaluate: 'Avaliar nova dívida',
      simulate: 'Simular',
      archive: 'Arquivar',
      generatePlan: 'Traçar plano de pagamento',
      regeneratePlan: 'Alterar plano',
      edit: 'Editar',
    },
    activePlan: {
      badge: 'Plano activo',
      title: 'O teu plano de pagamento',
      method: 'Caminho',
      predictedPayoff: 'Livre em',
      generatedOn: 'Plano gerado em',
      focusDebt: 'Dívida em foco',
      extraMonthly: 'Extra mensal sugerido',
      vaultLink: 'Ver cofre SMART',
    },
    repaymentWizard: {
      title: 'Plano de libertação',
      subtitle: 'Escolhe o que te move e define um extra mensal realista.',
      continue: 'Continuar',
      context: {
        eyebrow: 'A estratégia',
        title: 'Como te vais libertar das dívidas',
        lead: 'Não é magia, é um método simples. Em dois pontos:',
        points: [
          'Pagas sempre o mínimo de todas as dívidas, para nenhuma ficar para trás.',
          'Depois concentras todo o dinheiro extra numa só: a prioridade. Quando cai, o dinheiro dela junta-se à seguinte. É o efeito bola de neve.',
        ],
        helpNote:
          'A seguir escolhes qual é a prioridade, e nós mostramos-te o impacto de cada escolha.',
        cta: 'Escolher a minha estratégia',
      },
      contextIntro:
        'Não é magia, é um método simples. Em dois pontos:',
      contextSteps: [
        'Pagas sempre o mínimo de todas as dívidas, para nenhuma ficar para trás.',
        'Depois concentras todo o dinheiro extra numa só: a prioridade. Quando cai, o dinheiro dela junta-se à seguinte. É o efeito bola de neve.',
      ],
      allActiveDebts: 'Dívidas activas',
      method: {
        eyebrow: 'A tua prioridade',
        title: 'O que te motiva mais?',
        subtitle: 'As duas funcionam. Escolhe a que te faz continuar.',
      },
      methods: {
        avalanche: {
          title: 'Pagar menos juros no total',
          summary: 'Começa pela dívida de juro mais alto',
          description:
            'Atacas primeiro a dívida de juro mais alto. Poupa o máximo de dinheiro no caminho.',
          methodNote: '(método avalanche)',
          shortNote: '(avalanche)',
          benefitLabel: 'Menos juros',
          pro: 'Poupas mais em juros no total.',
          con: 'A primeira vitória pode demorar mais.',
        },
        snowball: {
          title: 'Sentir vitórias mais cedo',
          summary: 'Começa pela dívida mais pequena',
          description:
            'Eliminas primeiro a dívida mais pequena. Cada uma que cai dá-te gás para a seguinte.',
          methodNote: '(método snowball)',
          shortNote: '(snowball)',
          benefitLabel: 'Vitórias cedo',
          pro: 'Motivação mais rápida com vitórias cedo.',
          con: 'Podes pagar um pouco mais de juros no total.',
        },
      },
      simulate: {
        eyebrow: 'O acelerador',
        title: 'Quanto extra por mês?',
        subtitle:
          'Cada euro a mais que juntas ao mínimo aproxima o dia em que ficas livre. Experimenta.',
        extraPerMonth: '+ {amount} € por mês',
        freeIn: 'Livre em {date}',
        monthsEarlier: '{n} {monthsWord} mais cedo',
        monthsWordOne: 'mês',
        monthsWordMany: 'meses',
        interestSavedChip: 'poupas {amount} €',
        baselineHint: 'Este é o plano só com os mínimos. Desliza para acelerar.',
        halfSuggestion: 'Sugestão: ≈ metade da prestação',
        requiresData: 'Indica a prestação mensal na ficha da dívida para simular.',
        editDebt: 'Editar dívida',
      },
      amortizationIntro:
        'Simulação para «{name}»: ajusta o extra mensal e vê o impacto na dívida prioritária.',
      extraMonthlyLabel: 'Extra mensal (EUR)',
      useSuggestion: 'Usar sugestão (½ prestação)',
      suggestedExtra: 'Sugestão',
      halfPaymentHint: '≈ metade da prestação mensal',
      predictedPayoff: 'Livre em',
      editDebt: 'Editar dívida',
      lowBenefitHint:
        'Este é o plano só com os mínimos. Desliza para acelerar.',
      vault: {
        eyebrow: 'Garantir o plano · opcional',
        title: 'Queres blindar este extra?',
        subtitle:
          'Um cofre reserva o teu extra automaticamente a cada ciclo: assim o dinheiro não “desaparece” antes de pagar a dívida.',
        vaultName: 'Cofre “Livre de dívidas”',
        vaultOnHint: 'Reserva {amount} €/mês, automático',
        vaultOffHint: 'Sem cofre, giro o extra à mão',
        footerHint: 'Podes ligar ou desligar o cofre quando quiseres.',
        createAndFinish: 'Criar cofre e concluir',
        finishWithout: 'Concluir plano',
        skip: 'Não quero cofre, continuar',
      },
      vaultIntro:
        'Queres reservar {amount}/mês num cofre para garantir este plano?',
      vaultCheckbox: 'Criar ou actualizar cofre SMART para este plano',
      vaultGoalName: 'Livre de dívidas',
      vaultDescription:
        'Reserva automática para acelerar o caminho até ficares livre das dívidas.',
      done: {
        eyebrow: 'O teu plano está pronto',
        title: 'Livre em {date}',
        subtitle:
          'Tens um caminho claro à tua frente. Um euro de cada vez, e este dia chega mais cedo do que imaginas.',
        strategy: 'Estratégia',
        extraMonthly: 'Extra mensal',
        extraMonthlyValue: '{amount} € / mês',
        interestSaved: 'Poupança em juros',
        interestSavedValue: '{amount} €',
        cta: 'Ver as minhas dívidas',
      },
      finish: 'Concluir plano',
      saved: 'Plano guardado.',
    },
    toasts: {
      created: 'Dívida registada.',
      updated: 'Dívida actualizada.',
      archived: 'Dívida arquivada.',
    },
  },
  cycleSettings: {
    title: 'Definições do ciclo',
    subtitle:
      'Define o período em curso. Os próximos ciclos seguem o mesmo dia de fecho até alterares aqui outra vez.',
    saved: 'Ciclo actualizado.',
    saveError: 'Não foi possível guardar o ciclo.',
    currentCycle: {
      startLabel: 'Início do ciclo',
      endLabel: 'Fim do ciclo',
      periodLabel: 'Período actual: {period}',
      readOnlyHint:
        'Só podes ajustar o período enquanto estiveres no ciclo actual (não fechado).',
      noCycleYet:
        'Ainda não há ciclo aberto. Faz a primeira selfie para começar.',
    },
    selfiesLink: 'Ver selfies financeiras',
  },
  settings: {
    title: 'Definições',
    subtitle: 'Preferências da app, emails e lembretes.',
    hub: {
      anonymousName: 'Utilizador',
      editProfile: 'Editar',
      themeAuto: 'Auto',
      shortcutBadge: 'Atalho',
      groups: {
        account: 'A minha conta',
        notifications: 'Como a app me avisa',
        personalisation: 'Como a app funciona para mim',
        help: 'Ajuda e sobre',
      },
      profile: {
        title: 'Perfil',
        description: 'Nome, situação, dependentes',
      },
      account: {
        title: 'Email e password',
        description: 'Alterar acesso à conta',
      },
      prefsSaved: 'Preferências guardadas.',
      notifications: {
        title: 'Notificações',
        description: 'Alertas de orçamento, marketing',
      },
      reminders: {
        title: 'Lembretes',
        description: 'Selfie, calendário anual',
      },
      emailAlerts: {
        title: 'Avisos essenciais por email',
        description:
          'Alertas de orçamento e avisos da conta. Emails críticos (ex.: reset de password) continuam a ser enviados.',
      },
      productUpdates: {
        title: 'Novidades do produto',
        description: 'Avisos de novas funcionalidades. Não inclui a newsletter, essa é opt-in à parte.',
      },
      marketing: {
        title: 'Novidades e dicas',
        description: 'Ocasional, podes desligar quando quiseres',
      },
      selfieReminder: {
        title: 'Lembrete de selfie',
        description: '2 dias antes de fechar o ciclo',
      },
      annualReminder: {
        title: 'Lembrete de calendário anual',
        description: 'Despesas ocasionais a chegar (seguro, IMI, etc.)',
      },
      budgetMethod: {
        title: 'Método de orçamento',
        description: 'Como divides o teu dinheiro',
        emptyValue: 'Não definido',
      },
      cycleDay: {
        title: 'Dia de fecho do ciclo',
        description: 'Início do teu mês financeiro',
        value: 'Dia {day}',
      },
      appearance: {
        title: 'Aparência',
      },
      help: {
        title: 'Como funciona a app',
        description: 'Ciclo, selfie, cofres: relembra os conceitos',
      },
      terms: {
        title: 'Termos',
      },
      privacy: {
        title: 'Privacidade',
      },
      logout: {
        title: 'Terminar sessão',
      },
      deleteAccount: {
        title: 'Apagar conta',
        description: 'Apaga tudo, sem retorno',
      },
      version: 'EvPlanner · versão {version}',
    },
    profile: {
      section: 'A minha conta',
      title: 'O teu perfil',
      subtitle:
        'Estes dados ajudam a app a personalizar as sugestões: quanto guardar, que objetivos fazem sentido. Só pedimos o que usamos.',
      fullNameLabel: 'Como te chamas?',
      fullNameHint: 'É como te tratamos na app e nos relatórios.',
      employmentLabel: 'Situação profissional',
      employmentHint:
        'Ajuda-nos a perceber se o teu rendimento é fixo ou variável, para ajustar as dicas.',
      dependentsLabel: 'Pessoas a teu cargo',
      dependentsHint:
        'Usamos este número para sugerir margem de segurança e objectivos mais realistas.',
      whyTitle: 'Porque pedimos isto',
      whyBody:
        'Nunca vendemos estes dados. Servem só para calibrar dicas e simulações dentro da app.',
      submit: 'Guardar perfil',
      saved: 'Perfil actualizado.',
      nameError: 'Indica um nome com pelo menos 2 caracteres.',
      employmentOptions: {
        employee: 'Trabalhador por conta de outrem',
        self_employed: 'Freelancer',
        student: 'Estudante',
        retired: 'Reformado',
        other: 'Outra',
      },
    },
    account: {
      section: 'A minha conta',
      title: 'Email e password',
      subtitle: 'Mantém o acesso à tua conta seguro.',
      emailLabel: 'Email actual',
      emailHint:
        'Para mudar o email, enviamos um link de confirmação para o novo endereço.',
      newEmailLabel: 'Novo email',
      currentPasswordLabel: 'Password actual',
      requestEmailChange: 'Pedir alteração de email',
      emailChangeSent:
        'Enviámos um link de confirmação para o novo email. Abre-o para concluir a alteração.',
      passwordSection: 'Alterar password',
      oldPasswordLabel: 'Password actual',
      newPasswordLabel: 'Nova password',
      confirmPasswordLabel: 'Confirmar nova password',
      passwordMismatch: 'As passwords não coincidem.',
      passwordChanged: 'Password actualizada.',
      submitPassword: 'Guardar alterações',
    },
    budgetMethod: {
      section: 'Como a app funciona para mim',
      title: 'Como divides o teu dinheiro',
      navTitle: 'Método',
      subtitle:
        'O método de orçamento é a regra que reparte o teu rendimento por grupos. Podes mudá-la quando quiseres, escolhe a que faz mais sentido para ti agora.',
      warning:
        'Mudar o método redistribui os limites do teu orçamento atual. O que já gastaste este ciclo mantém-se, só mudam os alvos daqui para a frente.',
      submit: 'Guardar método',
      saved: 'Método actualizado.',
    },
    cycleDay: {
      section: 'Como a app funciona para mim',
      title: 'Dia de fecho do ciclo',
      navTitle: 'Dia de fecho',
      subtitle:
        'O ciclo é o teu mês financeiro pessoal: vai de um dia de fecho ao seguinte, não do calendário. Ao mudar o dia, o padrão de fecho futuro altera-se.',
      hint: 'Este dia define quando o teu mês pessoal recomeça e quando a selfie fecha o ciclo.',
      currentPeriod: 'O teu ciclo actual vai de {start} a {end}.',
      previewPeriod: 'Com o dia {day}, um ciclo neste padrão iria de {start} a {end}.',
      submit: 'Guardar dia',
      saved: 'Dia do ciclo actualizado.',
    },
    help: {
      section: 'Ajuda e sobre',
      title: 'Como funciona a app',
      subtitle: 'Uma visão rápida dos conceitos principais do EvPlanner.',
      items: [
        {
          title: 'Ciclo financeiro',
          body: 'O teu mês pessoal vai do dia de fecho ao dia de fecho seguinte, não é o mês do calendário.',
        },
        {
          title: 'Selfie financeira',
          body: 'Uma vez por ciclo registas saldos e vês a evolução do teu património.',
        },
        {
          title: 'Método de orçamento',
          body: 'Divides o rendimento em grupos (ex.: 50/30/20) para planear despesas e poupança.',
        },
        {
          title: 'Cofres e objectivos',
          body: 'Reservas dinheiro para despesas futuras ou metas SMART com prazo.',
        },
      ],
    },
    logout: {
      title: 'Terminar sessão?',
      body: 'Vais sair deste dispositivo. Os teus dados mantêm-se na conta.',
      confirm: 'Terminar sessão',
    },
    deleteAccount: {
      section: 'A minha conta',
      title: 'Apagar a tua conta',
      subtitle:
        'Tens o direito de apagar tudo o que é teu. Antes de o fazeres, vê o que acontece: é permanente e não reversível.',
      intro:
        'Tens o direito de apagar tudo o que é teu. Antes de o fazeres, vê o que acontece: é permanente e não reversível.',
      consequences: [
        'Perdes para sempre todas as tuas selfies, o histórico de património, orçamentos, objectivos e cofres.',
        'A tua evolução mês a mês não pode ser recuperada depois de apagada.',
        'Perdes o acesso imediatamente após confirmar.',
      ],
      keepNote: 'Podes pedir uma cópia dos teus dados antes, para guardares um arquivo.',
      alternativesTitle: 'Preferes outra opção?',
      exportTitle: 'Exportar os meus dados primeiro',
      exportDesc: 'Pede uma cópia por email (RGPD) antes de apagar',
      exportHref: 'mailto:apoio@evplanner.eu?subject=Pedido%20de%20exporta%C3%A7%C3%A3o%20de%20dados',
      logoutAltTitle: 'Só terminar sessão',
      logoutAltDesc: 'Sai sem apagar nada',
      confirmLabel: 'Para confirmar, escreve APAGAR abaixo',
      passwordLabel: 'Password actual',
      submit: 'Apagar a minha conta',
      cancel: 'Cancelar, manter a minha conta',
      success: 'Conta apagada.',
    },
    appearance: {
      title: 'Aparência',
      subtitle: 'Escolhe o tema claro, escuro ou automático do sistema.',
      cardTitle: 'Tema',
      cardDesc: 'A preferência fica guardada neste dispositivo.',
      options: {
        light: {
          title: 'Claro',
          description: 'Fundo claro em todos os ecrãs.',
        },
        dark: {
          title: 'Escuro',
          description: 'Menos brilho, ideal à noite.',
        },
        system: {
          title: 'Sistema',
          description: 'Segue a definição do teu dispositivo.',
        },
      },
    },
    recurringLink: 'Despesas recorrentes',
    recurringDesc: 'Templates mensais ou anuais com lançamento automático.',
    annualLink: 'Despesas anuais ocasionais',
    annualDesc: 'Lembra-te de pagamentos que voltam todos os anos.',
    selfieLink: 'Lembrete da selfie',
    selfieDesc: 'Activa ou desactiva alertas por tipo.',
    reminders: {
      title: 'Lembretes',
      subtitle: 'Escolhe que alertas queres receber na app ou por email.',
      cardTitle: 'Tipos de lembrete',
      cardDesc: 'Cada lembrete usa as datas que já definiste noutras partes da app.',
      selfieTitle: 'Selfie financeira',
      selfieDesc: 'Alerta no dia da selfie para registares os saldos do mês.',
      annualTitle: 'Calendário anual',
      annualDesc: 'Alertas de despesas ocasionais (seguro, IMI, etc.) no dashboard.',
      saved: 'Preferências guardadas.',
    },
    notifications: {
      title: 'Notificações',
      subtitle: 'Controla que emails recebes do EvPlanner.',
      productTitle: 'Emails da app',
      productDesc: 'Alertas operacionais e novidades sobre funcionalidades do EvPlanner.',
      emailAlertsTitle: 'Alertas por email',
      emailAlertsDesc:
        'Avisos de orçamento, confirmações de conta e alterações de password. Desactivar impede a maioria dos emails não obrigatórios.',
      productUpdatesTitle: 'Novidades do produto',
      productUpdatesDesc:
        'Avisos de novas funcionalidades e alterações importantes na app. Não inclui a newsletter educativa, essa requer opt-in separado.',
      selfieTitle: 'Lembrete da selfie',
      selfieDesc: 'Email no dia escolhido para registares os saldos do mês.',
      marketingTitle: 'Newsletter e conteúdo educativo',
      marketingDesc:
        'Dicas semanais de finanças pessoais e emails de reengagement. Novidades de produto têm toggle separado acima.',
      marketingToggleTitle: 'Receber emails de marketing',
      marketingToggleDesc:
        'Máximo ~1 email por semana. Podes cancelar a qualquer momento nas definições ou no link do email.',
      marketingLegal:
        'Ao activar, autorizas o envio de comunicações de marketing para o teu email. O consentimento fica registado com data e origem (RGPD).',
      saved: 'Preferências guardadas.',
    },
    selfie: {
      title: 'Lembrete da selfie',
      subtitle: 'Definimos um dia fixo do mês para registares os saldos. Recomendado: dia 1.',
      dayOfMonth: 'Dia do mês',
      hour: 'Hora do lembrete',
      enabled: 'Lembretes activos',
      submit: 'Guardar preferências',
      saved: 'Preferências guardadas.',
    },
    recurring: {
      title: 'Despesas recorrentes',
      subtitle: 'Gerir templates e lançar manualmente quando precisares.',
      add: 'Novo template',
      empty: 'Ainda não tens templates recorrentes.',
      launchNow: 'Lançar agora',
      nextRun: 'Próximo lançamento',
      cadenceMonthly: 'Mensal',
      cadenceYearly: 'Anual',
      form: {
        titleCreate: 'Novo template recorrente',
        titleEdit: 'Editar template',
        name: 'Nome',
        category: 'Categoria',
        amount: 'Valor por defeito',
        cadence: 'Cadência',
        dayOfMonth: 'Dia do mês',
        monthOfYear: 'Mês (anual)',
        startDate: 'Data de início',
        endDate: 'Data de fim (opcional)',
        autoLaunch: 'Lançamento automático activo',
        submit: 'Guardar',
      },
    },
    annual: {
      title: 'Despesas anuais ocasionais',
      subtitle: 'Pagamentos previstos por mês (ex.: IUC, IMI).',
      add: 'Adicionar',
      empty: 'Sem entradas por agora.',
      form: {
        titleCreate: 'Nova despesa anual',
        titleEdit: 'Editar',
        name: 'Nome',
        amount: 'Valor',
        month: 'Mês',
        day: 'Dia',
        allocationLabel: 'Classificação no orçamento',
        allocationHelp:
          'O cofre de suavização aparece no grupo correspondente do teu método.',
        allocationOptions: {
          essential: 'Essenciais',
          lifestyle: 'Não essenciais',
          personal_investment: 'Investimento',
        },
        allocationHints: {
          essential: 'Ex.: renda, supermercado, seguros: grupo Necessidades.',
          lifestyle: 'Ex.: restaurantes, lazer, subscrições: grupo Desejos.',
          personal_investment:
            'Ex.: formação, ETFs: grupo Poupança e investimento (fatia reservada).',
        },
        year: 'Ano',
        yearAll: 'Todos os anos',
        createSmoothingPot: 'Criar cofre de suavização',
        createSmoothingPotHint:
          'Reserva mensal no orçamento até ao pagamento. Sem marcar, ficas só com lembretes e alertas.',
        monthlySimulationTitle: 'Poupança mensal estimada',
        monthlySimulation:
          'Cerca de {amount} por mês durante {months} meses até ao pagamento.',
        potOnSaveHint:
          'Ao guardar, criamos o cofre de suavização com este valor mensal.',
        editHasPotHint:
          'Já tens um cofre ligado a esta despesa. Alterações ao valor reflectem-se no planeamento do cofre.',
        notes: 'Notas',
        submit: 'Guardar',
      },
      // CHANGE v2 §17: toasts usados pelo calendário anual.
      toast: {
        created: 'Despesa anual criada.',
        updated: 'Despesa anual actualizada.',
        deleted: 'Despesa anual removida.',
      },
    },
  },
  legal: {
    eyebrow: 'LEGAL',
    terms: {
      title: 'Termos e Condições',
      placeholder:
        'Esta é uma versão preliminar. Vai ser substituída pelo texto legal final antes do lançamento público.',
      bullets: [
        'Versão preliminar, não vinculativa.',
        'Os dados são guardados em servidores na União Europeia.',
        'Podes apagar a tua conta a qualquer momento nas Definições.',
      ],
      privacyLink: 'Ver Política de Privacidade',
    },
    privacy: {
      title: 'Política de Privacidade',
      intro:
        'O EvPlanner trata os teus dados pessoais em conformidade com o RGPD. Esta página resume como usamos cookies e quais são os teus direitos.',
      termsLink: 'Ver Termos e Condições',
      sections: {
        cookies: {
          title: 'Cookies',
          body:
            'Quando visitas a app ou o site, podemos guardar pequenos ficheiros (cookies) no teu browser. Podes gerir preferências no banner de cookies na primeira visita.',
          items: [
            'Necessários: autenticação segura (JWT em cookies HttpOnly), protecção CSRF e preferências da conta.',
            'Analíticos (opcionais): estatísticas agregadas de utilização, apenas se aceitares.',
            'Marketing (opcionais): medição de campanhas, apenas se aceitares.',
          ],
        },
        rights: {
          title: 'Os teus direitos',
          body:
            'Podes pedir acesso, rectificação ou eliminação dos teus dados contactando apoio@evplanner.eu. Para emails de marketing, usa também as definições de notificações na app.',
        },
      },
    },
  },
  faq: {
    eyebrow: 'AJUDA',
    title: 'Perguntas frequentes',
    items: [
      {
        question: 'O que é o EvPlanner?',
        answer:
          'App de gestão financeira pessoal PT-PT que educa enquanto guia: despesas/rendimentos por ciclo, orçamento, objetivos, cofres, fundo de emergência, património e selfie financeira mensal com relatório IA.',
      },
      {
        question: 'O que é o "ciclo financeiro"?',
        answer:
          'Período mensal definido por ti (o teu dia de fecho/selfie): dashboard, orçamento e rendimentos seguem sempre o ciclo actual.',
      },
      {
        question: 'É gratuito?',
        answer:
          'Sim, o EvPlanner está em beta privado e é gratuito; ainda não existem subscrições pagas.',
      },
      {
        question: 'Os meus dados estão seguros?',
        answer:
          'Autenticação por JWT em cookies HttpOnly, dados guardados em servidores na UE; podes apagar a tua conta a qualquer momento nas Definições.',
      },
      {
        question: 'Posso entrar com a conta Google?',
        answer: 'Sim, login/registo por email+password ou Google OAuth.',
      },
      {
        question: 'O que é a Evolution AI?',
        answer:
          'Assistente com acesso aos teus dados reais, disponível nas páginas principais, que ajuda a interpretar o teu histórico.',
      },
      {
        question: 'Existe app para telemóvel?',
        answer:
          'Ainda não há app nativa iOS/Android; o EvPlanner é uma web app responsiva (funciona bem no telemóvel).',
      },
      {
        question: 'Como cancelo/apago a minha conta?',
        answer: 'Definições → grupo final → apagar conta.',
      },
    ],
  },
  contact: {
    eyebrow: 'CONTACTO',
    title: 'Contacta-nos',
    lead: 'Tens uma dúvida ou sugestão? Escreve-nos: respondemos o mais rápido possível.',
    form: {
      name: { label: 'Nome', placeholder: 'O teu nome' },
      email: { label: 'Email', placeholder: 'tu@exemplo.pt' },
      message: { label: 'Mensagem', placeholder: 'Escreve aqui a tua mensagem…' },
      submit: 'Enviar',
    },
    altEmail: 'Ou escreve diretamente para apoio@evplanner.eu',
    supportEmail: 'apoio@evplanner.eu',
    errors: {
      name: 'Indica o teu nome.',
      email: 'Indica um email válido.',
      message: 'Escreve a tua mensagem.',
    },
    toastOpening: 'A abrir o teu email…',
  },
  about: {
    eyebrow: 'SOBRE',
    title: 'Sobre o EvPlanner',
    mission:
      'O EvPlanner educa enquanto guia: ajudamos-te a perceber o teu dinheiro em vez de te limitares a registá-lo.',
    body: [
      'Tudo no EvPlanner gira à volta do teu ciclo financeiro: um período mensal que começa no dia que faz sentido para ti, e não no dia 1 do calendário. Dentro de cada ciclo registas despesas e rendimentos e distribuis o teu dinheiro por um orçamento com método (por exemplo 50/30/20: necessidades, desejos e poupança).',
      'A partir daí construis o resto: objetivos SMART com prazo e valor definidos, cofres para separar o dinheiro que já tem dono, e um fundo de emergência dimensionado às tuas despesas fixas: a rede que evita que um imprevisto desfaça meses de trabalho.',
      'No fim de cada ciclo tiras uma selfie financeira: uma fotografia do teu património (ativos menos dívidas), da tua taxa de poupança e da evolução face aos ciclos anteriores, acompanhada de um relatório escrito pela Evolution AI que explica o que mudou e porquê.',
    ],
  },
  evolutionAi: {
    title: 'Pergunte ao Evolution AI',
    subtitle: 'Consultor de finanças pessoais com os teus números (PT-PT)',
    cardLabel: 'Evolution AI',
    getStarted: 'Começa por…',
    placeholder: 'Escreve a tua pergunta…',
    send: 'Enviar',
    thinking: 'A pensar…',
    offTopic:
      'Só posso ajudar com finanças pessoais e com o teu plano no EvPlanner. Reformula a pergunta nesse contexto.',
    rateLimited: 'Atingiste o limite diário de perguntas. Tenta amanhã.',
    error: 'Não foi possível obter resposta. Tenta outra vez.',
    suggestedTitle: 'Perguntas sugeridas',
    openAssistant: 'Abrir assistente Evolution AI',
    close: 'Fechar',
    emptyHint: 'Escolhe uma pergunta sugerida ou escreve a tua.',
    history: 'Histórico de conversas',
    historyTitle: 'Conversas',
    historyEmpty: 'Ainda não tens conversas guardadas.',
    historyEmptyHint: 'Faz uma pergunta ao Evolution AI para começar.',
    newChat: 'Nova conversa',
    backToChat: 'Voltar ao chat',
    untitledSession: 'Conversa sem título',
  },
  /** Molde partilhado de wizards (`components/wizard/`). */
  wizard: {
    common: {
      stepLabel: 'Passo {current} de {total}',
      percent: '{pct}%',
      continue: 'Continuar',
      skipLater: 'Saltar, faço isto depois',
      loadingDefault: 'A processar…',
      howItWorks: 'Como funciona',
      doneTitle: 'Está tudo pronto!',
      nextLabel: 'A seguir:',
      // .pen `ds/wizard/header` › `save-exit` (ícone floppy-disk)
      saveExit: 'Guardar e sair',
      // .pen frames `Onboarding · Pronto` › pills › `edit`
      edit: 'Editar',
    },
  },
  common: {
    cycleTooltip:
      'O teu ciclo financeiro vai do dia de fecho ao dia de fecho seguinte, não é o mês do calendário. É o ritmo do teu dinheiro.',
    archivedSection: {
      title: 'Arquivados',
      hint: 'Não aparecem em novos registos. Os dados antigos mantêm-se.',
    },
    loading: 'A carregar…',
    retry: 'Tentar de novo',
    // .pen `ds/card/*-group` › `error` › `err-action`
    tryAgain: 'Tentar novamente',
    // .pen `ds/card/cycle-header` / `ds/card/cycle-summary` › `error`
    cycleLoadError: 'Não foi possível carregar o ciclo agora',
    // .pen `ds/card/networth-hero` / `--empty` / `ds/card/networth-readout` › `error`
    netWorthLoadError: 'Não foi possível carregar o património agora',
    // .pen `ds/chart/donut` › `error` · `ds/chart/area` › `error` ·
    // `ds/chart/ring-progress` › `empty`
    charts: {
      distributionError: 'Não foi possível carregar a distribuição agora',
      distributionEmpty:
        'Ainda não há dados neste ciclo para mostrar a distribuição.',
      evolutionError: 'Não foi possível carregar a evolução agora',
      noData: 'sem dados',
    },
    // CHANGE v2 §5: usado para "Voltar atrás" no onboarding.
    back: 'Voltar atrás',
    next: 'Continuar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'A guardar…',
    saved: 'Guardado.',
    delete: 'Eliminar',
    logout: 'Sair',
    yes: 'Sim',
    no: 'Não',
    notFoundTitle: 'Página não encontrada',
    notFoundBody: 'A página que procuras não existe ou foi movida.',
    errorTitle: 'Algo correu mal',
    errorBody: 'Encontrámos um problema inesperado. Tenta de novo daqui a pouco.',
  },
  onboardingGoals: {
    intro: {
      badge: 'Vision Board',
      title: 'Os teus objectivos contam.',
      subtitle:
        'Antes de gastar com calma, vale a pena escolher para onde estamos a remar. Define o primeiro objectivo em poucos minutos, podes mudar quando quiseres.',
      bulletA: 'Define quanto precisas e até quando.',
      bulletB: 'Reservamos automaticamente o que precisas todos os meses.',
      bulletC: 'Marca o teu Vision Board com a tua razão mais profunda.',
      cta: 'Criar primeiro objectivo',
      skip: 'Saltar por agora',
    },
  },
  goals: {
    title: 'Objetivos',
    subtitle: 'Cria objectivos SMART e acompanha o teu progresso.',
    new: 'Novo objectivo',
    empty: {
      title: 'Sem objectivos por enquanto',
      body: 'Sonha em grande e divide-o em passos mensais. Os primeiros 1.000€ são o passo mais difícil.',
      cta: 'Criar primeiro objectivo',
    },
    // CHANGE v2 §14.1: PLEASURE removido. §14.3: priority removido.
    groups: {
      short: 'Curto prazo',
      medium: 'Médio prazo',
      long: 'Longo prazo',
    },
    status: {
      active: 'Activo',
      paused: 'Pausado',
      completed: 'Concluído',
      cancelled: 'Cancelado',
    },
    measurementType: {
      monetary: 'Valor (cofre)',
      checklist: 'Checklist',
      monetaryBadge: '€',
      checklistBadge: 'Lista',
      chooseTitle: 'Que tipo de objetivo?',
      chooseMonetary: 'Objetivo com valor',
      chooseMonetaryHelp:
        'Poupar uma quantia: férias, entrada de casa, um carro. Definimos quanto pôr de lado por mês.',
      chooseChecklist: 'Checklist',
      chooseChecklistHelp:
        'Uma lista de tarefas a cumprir: tratar de documentos, organizar papéis. Sem valor associado.',
    },
    wizard: {
      title: 'Novo objetivo',
      titleEdit: 'Editar objetivo',
      continueCta: 'Continuar',
      createCta: 'Criar objetivo',
      saveCta: 'Guardar alterações',
      skipImage: 'Adiciono uma imagem depois',
      doneCta: 'Ver os meus sonhos',
      doneCtaHome: 'Ver no Início',
      doneCtaDetail: 'Ver o objetivo',
      type: {
        eyebrow: 'Que tipo de objetivo?',
        title: 'O que queres alcançar?',
        subtitle: 'Há dois tipos. Escolhe o que encaixa, podes ter dos dois.',
      },
      essential: {
        eyebrow: 'O essencial',
        titleMonetary: 'Quanto e até quando?',
        subtitleMonetary: 'Dá um nome, um valor e uma data. Nós tratamos das contas.',
        titleChecklist: 'O essencial',
        subtitleChecklist: 'Dá um nome, um prazo e as primeiras tarefas.',
        nameLabel: 'Nome do objetivo',
        namePlaceholder: 'Ex.: Férias em família',
        amountLabel: 'Valor-alvo',
        dateLabel: 'Até quando',
        monthlyLabel: 'Reservar por mês',
        monthlyBreakdown: '{amount} € até {date} = {months} {unit}',
        monthSingular: 'mês',
        monthPlural: 'meses',
        withinBudget:
          'Cabe nos {budget}/mês livres da tua Poupança. Um plano tranquilo.',
        overBudget:
          'São mais do que os {budget}/mês livres na tua Poupança. Não faz mal, dá para ajustar: com este prazo o confortável é {max}, ou estica a data. Fica ao teu critério.',
        nameRequired: 'Indica um nome.',
        amountRequired: 'Indica um valor-alvo positivo.',
        dateRequired: 'Indica até quando.',
      },
      why: {
        eyebrow: 'O meu porquê',
        title: 'Porque é que isto importa para ti?',
        subtitle:
          'Escreve-o como o sentes. São estas palavras que vais ver quando a vontade fraquejar.',
        placeholder:
          'Ex.: Quero levar a minha família de férias sem pensar no dinheiro. Ver os miúdos na praia, sem contas na cabeça: é isso.',
        hint: 'Sem pressa. Podes voltar aqui sempre que quiseres.',
      },
      vision: {
        eyebrow: 'Vision board',
        title: 'Dá-lhe uma cara',
        subtitle:
          'Uma imagem que te faz querer chegar lá. Vais vê-la sempre que abrires o objetivo.',
        pickTitle: 'Escolhe uma imagem',
        pickHint: 'A praia, a casa, o carro: o que te move. Toca para procurar nas tuas fotos.',
        swap: 'Trocar',
      },
      done: {
        badge: 'Objetivo criado',
        badgeEdit: 'Alterações guardadas',
        title: 'É oficial. Vamos a isto!',
        subtitle:
          'O teu sonho já tem cara na página Objetivos. A cada fecho de ciclo lembramos-te de o alimentar.',
        monthlyRow: 'A reservar por mês',
        whyLabel: 'O meu porquê',
      },
    },
    checklist: {
      title: 'Tarefas',
      progress: '{done} de {total} tarefas',
      addTask: 'Adicionar tarefa',
      taskPlaceholder: 'Ex.: marcar exame de condução',
      removeTask: 'Remover',
      emptyTask: 'Indica pelo menos uma tarefa.',
      completeSuggestTitle: 'Objectivo concluído?',
      completeSuggestBody:
        'Marcaste a última tarefa. Este objectivo foi concluído na prática?',
      completeConfirm: 'Sim, está concluído',
      completeDismiss: 'Ainda não',
    },
    card: {
      progress: '{pct}% concluído',
      checklistProgress: '{done}/{total} tarefas',
      monthly: 'Reservar {amount}/mês',
      remaining: 'Faltam {amount}',
      targetDate: 'Até {date}',
      noTargetDate: 'Sem prazo definido',
      atRisk: 'Em risco',
      onTrack: 'No bom caminho',
    },
    detail: {
      progressTitle: 'Progresso',
      potTitle: 'Cofre associado',
      milestonesTitle: 'Marcos conquistados',
      historyTitle: 'Histórico de movimentos',
      editAriaLabel: 'Editar objectivo',
      cancelCta: 'Cancelar objectivo',
      cancelConfirmTitle: 'Cancelar este objectivo?',
      cancelConfirmBody:
        'O objectivo deixa de contar como activo, mas o cofre associado e todas as despesas registadas mantêm-se intactos. Podes removê-lo depois se quiseres.',
      deleteCta: 'Remover objectivo',
      deleteConfirmTitle: 'Remover objectivo?',
      deleteConfirmBody:
        'Esta acção é definitiva e remove o objectivo da tua lista.',
      deleteConfirmBodyWithPot:
        'O cofre associado será eliminado e todos os depósitos registados nesse cofre serão revertidos, como se nunca tivessem acontecido. Esta acção é definitiva.',
      completedBanner: 'Objectivo concluído.',
      cancelledBanner: 'Objectivo cancelado. Podes removê-lo quando quiseres.',
      autoCompleteHint:
        'Quando o cofre atingir 100% do valor alvo, o objectivo é marcado automaticamente como concluído.',
      contributeCta: 'Depositar',
      withdrawCta: 'Levantar',
      monthlyRow: 'A reservar por mês',
      whyLabel: 'O meu porquê',
      targetUntil: '{amount} € até {date}',
    },
    form: {
      titleCreate: 'Novo objectivo SMART',
      titleEdit: 'Editar objectivo',
      stepBasics: 'O essencial',
      stepWhy: 'O meu porquê',
      stepImage: 'Vision Board',
      nameLabel: 'Nome',
      namePlaceholder: 'Ex.: comprar uma mota',
      // CHANGE v2 §14.1: groupLabel agora é só display (badge), não input.
      groupLabel: 'Grupo',
      tasksLabel: 'Tarefas iniciais',
      editTasksLabel: 'Tarefas',
      targetAmountLabel: 'Quanto preciso?',
      targetDateLabel: 'Para quando?',
      targetDateHint: 'Indica o prazo: o grupo é calculado automaticamente.',
      allocationLabel: 'Impacto no orçamento',
      allocationHelp:
        'O cofre deste objectivo aparece no grupo correspondente do teu método (como nas despesas ocasionais).',
      // CHANGE v2 §14.2: monthly_amount é só leitura (calculado em tempo real).
      monthlyAmountLabel: 'Reservar por mês',
      monthlyAmountHelp: 'Calculado automaticamente a partir do prazo.',
      budgetExceeded:
        'Não tens orçamento disponível no grupo «{group}» para este reforço mensal.',
      budgetExceededDetail:
        'O máximo que podes planear é {remaining} (já há {allocated} em categorias e cofres; limite do grupo: {target}).',
      descriptionLabel: 'Descrição',
      whyLabel: 'Porque é importante para ti?',
      whyPlaceholder:
        'Escreve algumas frases inspiradoras. Vai aparecer no teu Vision Board.',
      iconLabel: 'Ícone (phosphor-icons)',
      imageLabel: 'Imagem',
      imageHelp: 'Carrega uma imagem que te motive (PNG ou JPG, até 5MB).',
      submitCreate: 'Criar objectivo',
      submitEdit: 'Guardar alterações',
    },
    summary: {
      activeCountLabel: 'Objectivos activos',
      activeCountOne: '1 objectivo activo',
      activeCountMany: '{count} objectivos activos',
      accumulatedLabel: 'Total acumulado',
      accumulatedHint:
        'Soma dos valores já guardados nos objectivos monetários activos.',
      monthlyPlanLabel: 'Plano mensal',
      monthlyPlanHint:
        'Soma do valor que reservas por mês para os objectivos monetários activos.',
      inactiveSection: 'Concluídos e cancelados',
      countOne: '1 objectivo',
      countMany: '{count} objectivos',
    },
    atRisk: {
      title: 'Objectivos em risco',
      body: 'Estes objectivos têm cofres com saldo abaixo do necessário para a data alvo.',
    },
    terms: {
      smart: {
        label: 'Objetivo SMART',
        body:
          'Um sonho com plano: específico, mensurável, alcançável, relevante e com prazo. Nós ajudamos-te com valor, data e o cofre: tu trazes o porquê.',
      },
      monetary: {
        label: 'Monetário',
        body:
          'Juntas dinheiro num cofre até ao valor-alvo e à data. Ideal para viagens, entrada de casa ou qualquer meta em euros.',
      },
      checklist: {
        label: 'Checklist',
        body:
          'Uma lista de tarefas a cumprir: documentos, passos práticos. Sem valor em euros; o progresso são os passos concluídos.',
      },
    },
    vision: {
      eyebrow: 'VISION BOARD',
      titlePopulated: 'Isto é o que estás a construir.',
      titleEmpty: 'Objetivos',
      activeSummaryOne: '1 objetivo ativo · metas SMART',
      activeSummaryMany: '{count} objetivos ativos · metas SMART',
      emptySummary: 'Ainda não há sonhos neste quadro · metas SMART',
      priorityBadge: 'PRIORITÁRIO',
      remainingLabel: 'FALTAM',
      remainingAmountPassos: '{count} passos',
      completedLabel: 'concluído',
      monthlyToSave: 'guardar {amount}/mês',
      targetMonthPill: 'Meta em {date}',
      viewGoalLink: 'Ver objetivo',
      moreActiveOne: '· mais 1 ativo',
      moreActiveMany: '· mais {count} ativos',
      dreamsLabel: 'OS TEUS SONHOS',
      checklistSteps: '{done} de {total} passos',
      yearEyebrow: 'O ANO À FRENTE',
      yearTitle: '{year} · sonhos e deveres',
      yearCardSub:
        'Onde é que os teus objetivos se cruzam com as despesas já marcadas.',
      yearFootDreamsOne: '1 sonho',
      yearFootDreamsMany: '{count} sonhos',
      yearFootDutiesOne: '1 dever',
      yearFootDutiesMany: '{count} deveres',
      yearCardLink: 'Ver calendário completo',
      legendDream: 'Sonho',
      legendDreamDesc: '· data-alvo de um objetivo teu',
      legendDuty: 'Dever',
      legendDutyDesc: '· despesa ocasional já planeada',
      allocation: {
        essential: 'Essencial',
        lifestyle: 'Prazer',
        investment: 'Investimento',
      },
      toneDone: 'concluído',
      toneOnTrack: 'a caminho',
      toneBehind: 'atrasado',
      toneUrgent: 'urgente',
      empty: {
        heroTitle: 'O que é que estás a construir?',
        heroBody:
          'Este é o teu quadro de sonhos: o lado da app que não fala de contas a pagar, mas daquilo por que vale a pena poupar.',
        smartNote:
          'Um objetivo SMART tem nome, tem valor (ou passos) e tem data. É isso que transforma um desejo vago em algo que dá para medir todos os meses.',
        cta: 'Criar o meu primeiro objetivo',
        startHereLabel: 'COMEÇA POR AQUI',
        startHereHint: '· toca para pré-preencher',
        typesLabel: 'DOIS TIPOS DE OBJETIVO',
        typesHint: '· escolhes ao criar',
        typeMonetaryLabel: 'Monetário',
        typeMonetaryBody:
          'Tens um valor-alvo e uma data. Mostramos-te quanto falta e quanto guardar por mês.',
        typeChecklistLabel: 'Checklist',
        typeChecklistBody:
          'Nem tudo se mede em euros. Divides o objetivo em passos e vais riscando à medida que avanças.',
      },
      examples: [
        {
          name: 'Fundo de emergência',
          description: '3 a 6 meses de despesas, para dormires descansado.',
          icon: 'shield-check',
          budget_allocation: 'essential',
        },
        {
          name: 'Viagem dos sonhos',
          description: 'Um destino, uma data e o valor a guardar todos os meses.',
          icon: 'airplane-tilt',
          budget_allocation: 'lifestyle',
        },
      ],
    },
  },
  pots: {
    title: 'Cofres',
    subtitle: 'Quanto do teu dinheiro já tem destino, e para quê.',
    sectionEyebrow: 'Os teus cofres · por propósito',
    monthlyCommitment: 'Compromisso mensal: {amount}',
    monthlyCommitmentLabel: 'Compromisso mensal',
    monthlyCommitmentHint:
      'Soma do reforço mensal recomendado para todos os cofres activos.',
    closedSection: 'Cofres fechados',
    treasury: {
      title: 'A tua tesouraria',
      reserved: 'Reservado',
      free: 'Livre',
      reservedLabel: 'reservado',
      hint:
        '{reserved} já têm dono (objectivos, ocasionais, emergência…). Só os {free} livres podes gastar sem mexer nos planos. Cada cofre gere-se na sua página.',
      noAssetsHint:
        'Regista os teus ativos líquidos para veres quanto do teu dinheiro está livre para gastar.',
      noAssetsCta: 'Adicionar ativos',
    },
    terms: {
      cofre: {
        label: 'Cofre',
        body:
          'Dinheiro que separas para um fim específico, para não o gastares sem querer. Cada cofre nasce num objectivo, numa despesa ocasional ou no fundo de emergência.',
      },
      reservedVsFree: {
        label: 'Reservado vs livre',
        body:
          'Reservado já tem dono (viagem, IUC, emergência…). Livre é o que podes gastar sem mexer nos planos. A soma dos cofres é o dinheiro afetado.',
      },
    },
    purposes: {
      dream: 'Sonhos',
      duty: 'Obrigações',
      safe: 'Segurança',
      other: 'Outros',
    },
    vaultRow: {
      ofTarget: 'de {amount}',
      forDate: 'para {date}',
      forMonth: 'para {month}',
      noDate: 'sem data',
      emergencyMeta: 'meta de emergência',
      emergencyMetaMonths: 'meta {months} meses',
      goToOrigin: 'Ir à origem',
    },
    move: {
      title: 'Mover entre cofres',
      fromLabel: 'De',
      toLabel: 'Para',
      amountLabel: 'Quanto',
      savedBalance: '{amount} guardados',
      remainingTarget: '{accumulated} · faltam {remaining}',
      note:
        'Estás só a reafetar dinheiro que já tens: o teu total reservado não muda, só o destino.',
      submit: 'Mover {amount}',
      chipAll: 'Tudo',
      pickFrom: 'Escolher cofre de origem',
      pickTo: 'Escolher cofre de destino',
      success: 'Dinheiro reafetado entre cofres.',
      needTwoPots: 'Precisas de pelo menos dois cofres activos para mover.',
      invalidAmount: 'Indica um valor válido.',
      insufficientBalance: 'Saldo insuficiente no cofre de origem.',
    },
    empty: {
      title: 'Ainda não tens dinheiro reservado',
      hero: 'Ainda não tens dinheiro reservado',
      bodyBefore: 'Um ',
      bodyHighlight: 'cofre',
      bodyAfter:
        ' é dinheiro que separas para um fim específico, para não o gastares sem querer. Aqui verás, num só sítio, quanto do teu dinheiro já tem destino.',
      bornNote:
        'Não precisas de criar cofres à mão: eles nascem sozinhos quando crias um objectivo ou uma despesa ocasional. Começa por aí.',
      ctaGoals: 'Criar um objectivo',
      ctaGoalsHint: 'Um sonho com um plano → cria um cofre',
      ctaCalendar: 'Explorar o Calendário Anual',
      ctaCalendarHint: 'Despesas ocasionais → cofre de suavização',
    },
    suggestions: {
      sectionTitle: 'Sugestões',
      sectionHint:
        'Tens despesas ocasionais sem cofre de suavização. Cria um cofre para ires poupando ao longo do ano.',
      itemMeta: '{month} · {category}',
      createPotCta: 'Criar cofre',
      potCreated: 'Cofre criado para a despesa ocasional.',
      summaryOne: '1 despesa ocasional sem cofre',
      summaryMany: '{count} despesas ocasionais sem cofre',
    },
    kinds: {
      goal: 'Objectivo',
      occasional: 'Ocasional',
    },
    contribute: {
      submit: 'Depositar',
      success: 'Depósito registado no cofre.',
    },
    activeCountLabel: 'Cofres activos',
    activeCountOne: '1 cofre activo',
    activeCountMany: '{count} cofres activos',
    progress: {
      accumulated: 'Acumulado',
      remaining: 'Em falta',
      monthlyRequired: 'Reforço mensal',
      monthsRemaining: 'Meses em falta',
      monthsRemainingOne: '1 mês',
      monthsRemainingMany: '{count} meses',
      monthsRemainingDone: 'Concluído',
      monthsRemainingUnknown: '—',
    },
    closedBadge: 'Cofre fechado',
    history: {
      title: 'Histórico',
      empty: 'Ainda não há depósitos neste cofre.',
      back: 'Voltar',
      editCta: 'Editar',
      deleteCta: 'Eliminar',
      deleteConfirm: 'Eliminar este depósito? A acção é definitiva.',
      noDescription: 'Sem descrição',
    },
    close: {
      cta: 'Fechar cofre',
      title: 'Fechar cofre',
      subtitle:
        'Decide o que fazer com os depósitos antes de arquivar este cofre.',
      revertAllLabel: 'Reverter todos os depósitos',
      revertAllHelp:
        'Apaga todas as despesas associadas ao cofre. Útil quando o cofre foi criado por engano ou quando vais reorganizar.',
      keepHistoryLabel: 'Manter histórico',
      keepHistoryHelp:
        'Mantém os depósitos como despesas confirmadas. Recomendado quando o cofre cumpriu o objectivo.',
      submit: 'Fechar cofre',
      cancel: 'Cancelar',
      success: 'Cofre fechado.',
    },
  },
  calendar: {
    title: 'Calendário Anual',
    subtitle:
      'Planeia despesas pontuais ao longo do ano: com lembretes ou cofres de suavização, à tua escolha.',
    desktopSummary: 'Despesas ocasionais · {annual} no ano · {monthly}/mês',
    monthlyTotal: 'Total',
    annualTotal: 'Total planeado',
    annualInPots: 'Nos cofres',
    annualRemaining: 'Em falta',
    reminderCount: '{count} só lembretes',
    withPotCount: '{count} com cofre',
    badgeReminder: 'Lembrete',
    badgePot: 'Cofre',
    reminderHint: 'alertas no dashboard',
    activatePot: 'Activar cofre',
    createPot: 'Cofre criado',
    empty: 'Nada planeado neste mês, podes adicionar uma despesa ocasional.',
    emptyShort: 'Sem eventos',
    gridLabel: 'Meses do ano',
    noItems: 'Nenhuma despesa planeada neste ano',
    itemCount: '{count} despesas',
    oneItem: '1 despesa',
    savedShort: 'poupado',
    addInMonth: 'Adicionar',
    deleteConfirmTitle: 'Apagar despesa ocasional?',
    deleteConfirmBody: 'Apagar esta despesa ocasional do calendário? Esta acção não pode ser desfeita.',
    deleteConfirm: 'Apagar',
    edit: 'Editar',
    delete: 'Apagar',
    fab: {
      create: 'Nova despesa',
    },
    plan: {
      eyebrow: 'Despesas ocasionais',
      eyebrowTooltip:
        'Pagamentos que só aparecem uma ou poucas vezes por ano: IUC, IMI, seguros, férias…',
      headline:
        'No ano tens {annual} em despesas que só aparecem uma vez. Se guardares {monthly}/mês, nenhuma te apanha desprevenido.',
      metricPlanned: 'No ano',
      metricPlannedHint: '{count} despesas',
      metricInPots: 'Nos cofres',
      metricInPotsHint: '{pct}%',
      metricRemaining: 'Em falta',
      metricRemainingHint: 'a guardar',
      // aliases usados por código legado
      metricYear: 'No ano',
      metricYearHint: '{count} despesas',
      metricReserved: 'Nos cofres',
      metricReservedHint: '{pct}%',
    },
    yearGrid: {
      eyebrow: 'O teu ano de relance',
      scaleLess: 'menos',
      scalePeak: 'pico',
      legendHeavy: 'Mês pesado (deveres)',
      legendDream: 'Sonho com data',
      subtitleMixed: '{duties} dever · {dreams} sonho',
      oneDream: '1 sonho',
      dreamCount: '{count} sonhos',
    },
    monthDetail: {
      title: '{month} · o que tens este mês',
      viewYear: 'Ver ano todo',
      badgeDuty: 'Dever',
      badgeDream: 'Sonho',
      smoothingPot: 'Cofre de suavização',
      goalPot: 'Cofre do objetivo',
      potTooltip:
        'Reserva mensal no orçamento até ao pagamento: quando chega a altura, já tens o dinheiro.',
      potComplete: 'Já tens tudo reservado',
      potPartial: 'Já juntaste {accumulated} €',
      potAmounts: '{accumulated} € de {amount} €',
      potRemaining: 'faltam {remaining} € · {monthly} €/mês',
      emptyMonth:
        'Neste mês ainda não há deveres nem sonhos. Se chega um pagamento pontual, adiciona-o já: assim o cofre começa a preparar-te.',
      emptyMonthCta: 'Adicionar neste mês',
      viewGoal: 'Ver objectivo',
    },
    emptyState: {
      title: 'Há despesas que só aparecem uma vez por ano, e apanham toda a gente.',
      example:
        'Imagina que em Maio tens 200 € de IUC. Se não te preparares, esse mês fica apertado.',
      solve:
        'Aqui ajudamos-te a guardar aos poucos ao longo do ano, com um cofre para cada uma: quando chega a altura de pagar, já não dói.',
      suggestionsEyebrow: 'Começa pelas mais comuns',
      suggestionsSub: 'Tens alguma destas? Toca para adicionar: nós preparamos o cofre.',
      customPrefix: 'Tens outra?',
      customLink: 'Adicionar despesa personalizada',
    },
    toast: {
      reminderCreated: 'Lembrete registado, vais ver alertas no dashboard.',
      potCreated: 'Despesa e cofre de suavização criados.',
    },
    form: {
      intro:
        'Regista o pagamento previsto. Ficas sempre com lembretes e alertas; o cofre é opcional.',
      titleCreate: 'Novo evento no calendário',
      titleEdit: 'Editar evento',
      name: 'Nome',
      amount: 'Valor previsto',
      month: 'Mês',
      day: 'Dia',
      year: 'Ano',
      yearAll: 'Todos os anos',
      createSmoothingPot: 'Criar cofre de suavização',
      createSmoothingPotHint:
        'Reserva mensal no orçamento até ao pagamento. Sem marcar, manténs só lembretes.',
      allocationLabel: 'Classificação no orçamento',
      allocationHelp:
        'Usada nos alertas e, se activares cofre, no grupo correspondente do método.',
      allocationOptions: {
        essential: 'Essenciais',
        lifestyle: 'Não essenciais',
        personal_investment: 'Investimento',
      },
      allocationHints: {
        essential: 'Ex.: IUC, seguros: grupo Necessidades.',
        lifestyle: 'Ex.: festas, viagens: grupo Desejos.',
        personal_investment:
          'Ex.: formação: grupo Poupança e investimento.',
      },
      monthlySimulationTitle: 'Poupança mensal estimada',
      monthlySimulation:
        'Cerca de {amount} por mês durante {months} meses até ao pagamento.',
      potOnSaveHint: 'Ao guardar, criamos o cofre com este valor mensal.',
      editHasPotHint:
        'Esta entrada já tem cofre. Altera o valor ou notas; o cofre mantém-se ligado.',
      notes: 'Notas (opcional)',
      submit: 'Guardar',
    },
  },
  visionBoard: {
    title: 'Vision Board',
    subtitle:
      'As tuas razões mais profundas para evoluir financeiramente. Volta aqui sempre que precisares.',
    addCta: 'Adicionar objectivo',
  },
  income: {
    title: 'Rendimentos',
    subtitle: 'O que recebeste neste ciclo.',
    sources: {
      title: 'Fontes de rendimento',
      pageTitle: 'De onde vem o dinheiro',
       subtitle: 'Organiza os rendimentos que dão forma ao teu planeamento financeiro.',
       addNew: 'Nova fonte',
      actions: {
        edit: 'Editar',
        archive: 'Arquivar',
        unarchive: 'Reactivar',
      },
      archivedToast: '{name} arquivada.',
      restoredToast: '{name} reactivada.',
       allArchivedHint: 'Todas as fontes estão arquivadas. Reactiva-as em baixo quando precisares.',
       listSection: 'As tuas fontes',
       summaryCard: {
         totalLabel: 'Total típico mensal',
         breakdownLabel: 'Distribuição por tipo de rendimento',
         countOne: '1 fonte',
         countMany: '{count} fontes',
       },
      empty: {
        title: 'Adiciona a tua primeira fonte',
        subtitle:
          'Começa pelo salário: a entrada com que mais contas. Depois podes acrescentar freelance, rendas ou extras.',
        body:
          'Começa pelo salário: a entrada com que mais contas. Depois podes acrescentar freelance, rendas ou extras.',
        cta: 'Adicionar fonte',
      },
      buckets: {
        guaranteed: 'Garantido',
        variable: 'Variável',
        occasional: 'Pontual',
      },
      netBadge: 'à mão',
      grossBadge: 'bruto',
      archivedHint: 'Não apaga o histórico de rendimentos, podes reativar.',
      activeLabel: 'Activa',
      archivedLabel: 'Arquivada',
      categories: {
        salary: 'Salário',
        freelance: 'Freelance',
        capital_gains: 'Capital',
        rental: 'Rendas',
        crypto: 'Cripto',
        extraordinary: 'Extra',
        secondary: 'Secundário',
        transfers: 'Transferências',
        other: 'Outro',
      },
      recurrence: {
        monthly_fixed: 'Mensal fixo',
        monthly_variable: 'Mensal variável',
        occasional: 'Pontual',
      },
      form: {
        titleCreate: 'Nova fonte',
        titleEdit: 'Editar fonte',
        nameLabel: 'Nome',
        namePlaceholder: 'Por exemplo, Salário',
        categoryLabel: 'Categoria',
        recurrenceLabel: 'Recorrência',
        baseAmountLabel: 'Valor típico mensal',
        baseAmountHelp: '(pré-preenche o registo)',
        isNetLabel: 'Líquido',
        isNetHelp: 'Indica se o valor já está líquido de impostos.',
        colorLabel: 'Cor',
        iconLabel: 'Ícone',
        notesLabel: 'Nota opcional',
        nameHelp: 'Como queres que apareça na lista.',
        submitCreate: 'Criar fonte',
        submitEdit: 'Guardar alterações',
        cancelCta: 'Cancelar',
        continueCta: 'Continuar',
        backCta: 'Voltar',
        changeRecurrence: 'Mudar',
      },
      wizard: {
        step1Title: 'Como é que o dinheiro entra',
        step1Help:
          'Começa por dizer como o dinheiro entra: é isso que define o grupo onde a fonte fica.',
        fixedTitle: 'Todos os meses, valor fixo',
        fixedDesc: 'Salário, rendas: o mesmo valor, sempre.',
        fixedBucket: 'Fica em Garantido',
        variableTitle: 'Todos os meses, valor que varia',
        variableDesc: 'Freelance, part-time, comissões.',
        variableBucket: 'Fica em Variável',
        occasionalTitle: 'De vez em quando',
        occasionalDesc: 'Extraordinários, cripto, capital, prendas.',
        occasionalBucket: 'Fica em Pontual',
        netQuestion: 'são o que recebes à mão (depois de impostos)?',
        netQuestionEmpty: 'O valor típico é o que recebes à mão (depois de impostos)?',
        netYesTitle: 'Sim, à mão',
        netYesDesc: 'É o que fica na conta. O mais comum.',
        netNoTitle: 'Não, é bruto',
        netNoDesc: 'Antes de impostos e descontos.',
        netNote:
          'À mão (líquido) é o dinheiro com que contas de facto. Bruto é antes de impostos: usa-o só se ainda não sabes o líquido.',
        colorIconOptional: 'Cor & ícone da fonte',
        colorIconHint: 'Opcional · como aparece na lista',
        optional: 'opcional',
      },
    },
    records: {
      title: 'Registo mensal',
      subtitle:
        'Indica quanto entrou no mês seleccionado por cada fonte. Podes ajustar a qualquer momento.',
      monthLabel: 'Mês',
      yearLabel: 'Ano',
      noSources:
        'Sem fontes ainda. Cria pelo menos uma fonte para registares rendimentos.',
      confirmCta: 'Confirmar mês',
      success: 'Mês actualizado.',
      totalForMonth: 'Total do mês',
    },
    allocate: {
      title: 'Alocar margem',
      subtitle:
        'Distribui a tua margem mensal entre cofres e ativos, sem stress.',
      marginAvailable: 'Margem disponível',
      totalAllocated: 'Total alocado',
      remaining: 'Sobra',
      overMargin: 'Excedeste a margem disponível.',
      addDestinationCta: 'Adicionar destino',
      removeDestinationCta: 'Remover',
      destinationType: {
        pot: 'Cofre',
        account: 'Ativo',
      },
      destinationTypeLabel: 'Tipo de destino',
      destinationTargetLabel: 'Destino',
      destinationAmountLabel: 'Valor (EUR)',
      kindLabel: 'Tipo',
      kindOptions: {
        savings: 'Poupança',
        investment: 'Investimento',
      },
      notesLabel: 'Nota opcional',
      confirmCta: 'Confirmar alocação',
      success: 'Alocação registada.',
      empty:
        'Adiciona pelo menos um destino para distribuir a margem deste mês.',
      noPots: 'Sem cofres activos. Cria um objectivo primeiro.',
      noAccounts: 'Sem ativos activos. Adiciona um ativo primeiro.',
    },
    summary: {
      income: 'Rendimentos',
      expenses: 'Despesas',
      margin: 'Margem',
      potTransfers: 'Em cofres',
      potTransfersHint: 'reserva para despesas futuras, não conta na taxa',
      saved: 'Poupado / investido',
      savingsRate: 'Taxa de poupança',
      investmentRate: 'Taxa de investimento',
      invested: 'Investido',
      totalAllocated: 'Alocado',
      remainingMargin: 'Por alocar',
    },
    benchmarks: {
      below_10: 'Abaixo de 10%',
      between_10_20: 'Entre 10% e 20%',
      between_20_30: 'Entre 20% e 30%',
      above_30: 'Acima de 30%',
      meets_method: 'Atingiste o alvo do método',
      below_method: 'Abaixo do alvo do método',
      well_below_method: 'Muito abaixo do alvo',
      below_10_hint: 'Procura libertar margem antes de pensar em investir.',
      between_10_20_hint: 'Estás no caminho. Sobe gradualmente.',
      between_20_30_hint: 'Excelente: equilíbrio entre conforto e progresso.',
      above_30_hint: 'Acima do recomendado mínimo. Bom para acelerar objectivos.',
      meets_method_hint:
        'A tua margem (rendimento menos despesas, incluindo cofres) atinge a fatia de poupança/investimento do método.',
      below_method_hint:
        'Ainda não reservaste a percentagem de poupança/investimento definida no método.',
      well_below_method_hint:
        'Reforça os depósitos em cofres ou contas para alinhares com o método.',
      methodTarget: 'Alvo do método: {pct}% ({amount})',
    },
    dashboard: {
      header: 'O teu mês em números',
      noData: 'Ainda não há registos para o mês actual.',
      addFirstSource: 'Adicionar primeira fonte',
      goToRecords: 'Registar rendimentos do mês',
      goToAllocate: 'Alocar margem',
      goToSimulator: 'Simular',
    },
    hero: {
      cycleChip: 'Ciclo · {period}',
      receivedLabel: 'Recebido neste ciclo',
      plannedLine: 'de {planned} planeados',
      plannedTooltip:
        'Soma dos valores típicos mensais das tuas fontes activas: a base do teu orçamento. Podes ajustar em Gerir fontes.',
      belowPlannedContext:
        'Faltam {days} dias neste ciclo, ainda podes registar rendimentos.',
      daysLeftPrefix: 'faltam',
      daysLeftSuffix: 'dias',
      // `.pen` → `ds/card/cycle-spend-hero--income` › `hero` › `scale`.
      receivedPct: '{pct}% recebido',
      daysLeft: 'restam {days} dias',
      dayLeft: 'resta 1 dia',
      guaranteed: 'Garantido',
      uncertain: 'Incerto',
      guaranteedTooltip: 'Rendimento de fontes fixas (ex.: salário) já recebido neste ciclo.',
      uncertainTooltip:
        'Rendimento de fontes variáveis ou pontuais: entra mas muda de mês para mês.',
    },
    breakdown: {
      title: 'De onde vem',
      titleDesktop: 'Fontes',
      subtitle: 'fontes',
      pctOfCycle: '{pct}% do ciclo',
      empty: 'Ainda não há rendimentos registados neste ciclo.',
      seeAll: 'Ver todas as fontes',
      badgeFixed: 'Fixo',
      badgeVariable: 'Variável',
    },
    cycleRecords: {
      title: 'Registos do ciclo',
      subtitle: 'recentes primeiro',
      seeHistory: 'Ver histórico completo',
    },
    dashhead: {
      cycleSubtitle: 'Ciclo {period} · {received} de {planned}',
      cycleSubtitleReceivedOnly: 'Ciclo {period} · {received}',
    },
    cta: {
      newRecord: 'Registar mês',
      sources: 'Fontes',
      manageSources: 'Gerir fontes',
      addFirstSource: 'Adicionar fonte de rendimento',
      // CHANGE v2 §18: novo CTA de registo rápido (sheet inline).
      quickRegister: 'Registar rendimento',
    },
    // CHANGE v2 §18: QuickIncomeSheet — registo rápido.
    cycle: {
      label: 'Ciclo',
      current: 'Ciclo actual',
      past: 'Ciclo anterior',
      prev: 'Ciclo anterior',
      next: 'Ciclo seguinte',
      recordsHint:
        'Regista o que entrou neste período. Podes voltar a ciclos anteriores se já tiveres selfies.',
      readOnlyHint:
        'Ciclo anterior: apenas consulta. Regista ou edita rendimentos no ciclo actual.',
    },
    distribution: {
      title: 'Distribuição por tipo',
      subtitle: 'Como se reparte o rendimento do ciclo seleccionado (salário, freelance, etc.).',
      empty: 'Ainda não há rendimentos neste ciclo para mostrar a distribuição.',
      total: 'Total do ciclo',
    },
    evolution: {
      title: 'Evolução no tempo',
      subtitle: 'Rendimento total registado em cada ciclo (linha temporal entre selfies).',
      empty:
        'Ainda não há rendimentos nos ciclos recentes. Quando registares, vês a evolução aqui.',
      emptyNoCycles: 'Fecha a primeira selfie para começares a ver ciclos.',
      incomeLabel: 'Rendimento total',
    },
    list: {
      title: 'Rendimentos do ciclo',
      totalLabel: 'Total do ciclo',
      emptyTitle: 'Ainda sem rendimentos',
      empty:
        'Regista o que entrou neste ciclo (valor, data e fonte), como fazes com as despesas.',
      today: 'Hoje',
      yesterday: 'Ontem',
      edit: 'Editar rendimento',
      delete: 'Apagar rendimento',
      deleteConfirmTitle: 'Apagar rendimento?',
      deleteConfirmBody: 'Queres apagar o rendimento de {source}? Esta acção não pode ser desfeita.',
      deleteConfirm: 'Apagar',
      deletedToast: 'Rendimento apagado.',
      deleteError: 'Não foi possível apagar o rendimento.',
      byCategory: 'Por categoria no ciclo',
    },
    quickIncome: {
      title: 'Registar rendimento',
      editTitle: 'Editar rendimento',
      subtitle: 'Valor, fonte e está feito.',
      subtitleWithCycle: 'Ciclo {cycle} · valor, fonte e está feito.',
      sourceLabel: 'Fonte',
      dateLabel: 'Data',
      newSource: 'Nova fonte',
      amountLabel: 'Valor',
      amountPlaceholder: '0,00',
      notesLabel: 'Notas (opcional)',
      notesPlaceholder: 'Ex: subsídio de férias',
      submit: 'Guardar',
      successToast: 'Rendimento registado.',
      updatedToast: 'Rendimento actualizado.',
      noSources: 'Cria uma fonte de rendimento primeiro.',
      goToSources: 'Ir para fontes',
      showMoreSources: 'Ver mais fontes',
      sourcesModalTitle: 'Todas as fontes',
      sourcesModalDescription: 'Escolhe de onde veio o rendimento.',
    },
  },
  // CHANGE v2 §19: simulator strings removidas (página foi removida).
  onboardingIncome: {
    title: 'Próxima paragem: rendimentos',
    subtitle:
      'Para descobrires a tua taxa de poupança, precisamos do que entra todos os meses.',
    bullets: [
      'Define cada fonte: salário, freelance, rendas, etc.',
      'Regista quanto entrou em cada mês.',
      'A partir daí o EvPlanner calcula a tua taxa de poupança e investimento.',
    ],
    primaryCta: 'Adicionar primeira fonte',
    secondaryCta: 'Mais tarde',
  },
  emergencyFund: {
    title: 'Fundo de Emergência',
    subtitle: 'A tua rede de segurança: tranquilidade primeiro, detalhes depois.',
    terms: {
      emergencyFund: {
        label: 'Fundo de emergência',
        body: 'Dinheiro guardado para imprevistos: perder o emprego, uma avaria, uma urgência. É a tua rede de segurança.',
      },
      monthsCoverage: {
        label: 'Meses de cobertura',
        body: 'Quantos meses de despesas consegues cobrir com o que tens guardado. É o número que importa para dormires descansado.',
      },
      liquidity: {
        label: 'Liquidez',
        body: 'Quão rápido consegues usar o dinheiro sem penalizações. Conta à ordem = imediata; depósitos a prazo = demoram mais.',
      },
    },
    baseFund: 'Liquidez imediata',
    baseFundHint: 'Parte do fundo a que chegas no próprio dia.',
    ef: 'Fundo de Emergência',
    efHint: '3 a 12 meses de despesas essenciais.',
    currentAmount: 'Saldo actual',
    targetAmount: 'Alvo',
    peakAmount: 'Máximo histórico',
    totalTarget: 'Alvo total',
    replenishment: 'Reposição activa',
    replenishmentHint:
      'O fundo foi usado. Reconstrói até voltares ao máximo histórico.',
    semaphore: {
      red: 'Vermelho',
      yellow: 'Amarelo',
      green: 'Verde',
    },
    status: {
      title: 'Estado do fundo',
      empty:
        'Ainda não há saldo no Fundo de Emergência. Marca os ativos que constituem este colchão para começarmos a acompanhar.',
      baseCoverage: 'Cobertura em liquidez imediata',
      efCoverage: 'Cobertura do Fundo de Emergência',
    },
    target: {
      title: 'Alvo',
      automatic: 'Modo automático',
      custom: 'Modo personalizado',
      essentialAvg: 'Média de despesas essenciais',
      months: 'Meses cobertos',
      formula: 'Cálculo: {avg}/mês × {months} = {ef}',
      note:
        'Em modo automático calculamos a partir da média de despesas essenciais dos últimos meses.',
    },
    config: {
      title: 'Configuração',
      subtitle: 'Define a meta do teu Fundo de Emergência.',
      baseFundTargetLabel: 'Liquidez imediata (EUR)',
      modeLabel: 'Modo de cálculo',
      modeAutomatic: 'Automático',
      modeCustom: 'Personalizado',
      monthsLabel: 'Meses de cobertura',
      monthsHint: 'Entre 1 e 12 meses.',
      customTargetLabel: 'Alvo personalizado (EUR)',
      customTargetHint:
        'Aplicado apenas em modo personalizado. Substitui o valor calculado.',
      saveCta: 'Guardar configuração',
      success: 'Configuração actualizada.',
    },
    // CHANGE v2 §23: strategy + advice removidos — substituídos pelo health
    // endpoint + AI plan inline no dashboard.
    miniCard: {
      title: 'Fundo de Emergência',
      noConfig: 'Configura a tua rede de segurança.',
      cta: 'Abrir Fundo de Emergência',
      monthsCovered: 'meses cobertos',
      noSelfies:
        'Sem selfies: regista uma selfie para calcular a cobertura do fundo.',
      awaitingSelfiesMore:
        'Precisas de mais {count} selfie(s) para calcular a cobertura em meses.',
      allocatedLabel: 'Alocado em ativos de emergência',
    },
    dashboard: {
      setupTitle: 'Configura o teu Fundo de Emergência',
      setupSubtitle:
        'Um wizard passo a passo para definir a tua meta e marcar o que já tens guardado.',
      setupCta: 'Configurar Fundo de Emergência',
      setupComingSoonTitle: 'Fundo de Emergência',
      setupComingSoonBody:
        'Em breve vais poder configurar o teu Fundo de Emergência aqui.',
      progressTitle: 'Progresso do fundo',
      progressSubtitle: 'Alvos definidos na configuração do wizard.',
      targetsTitle: 'Meta do Fundo de Emergência',
      targetsSubtitle: 'Valores definidos na configuração do wizard.',
      targetBase: 'Liquidez imediata',
      targetEf: 'Fundo de Emergência',
      targetFps: 'Meta total',
      monthsUnit: 'meses',
      healthMonthsTitle: 'Cobertura estimada (despesas)',
      ofMonths: 'de',
      avgExpenses: 'Despesa média nos últimos 3 selfies: {amount}/mês',
      blockBaseTitle: 'Liquidez imediata',
      blockBaseHint: 'Dinheiro a que chegas no próprio dia.',
      blockEfTitle: 'Fundo de Emergência',
      blockEfHint: 'Cobertura de meses de despesas para imprevistos.',
      ofTarget: 'do alvo',
      complete: 'completo',
      allocationsTitle: 'Ativos alocados',
      editAllAllocations: 'Editar alocações',
      editAllocation: 'Editar alocação',
      accountBalance: 'Saldo (última selfie)',
      roleLiquidity: 'Liquidez',
      roleSaved: 'No fundo',
      noAllocations: 'Ainda não alocaste ativos ao fundo.',
      allocateCta: 'Alocar ativos',
      planSection: {
        title: 'Onde guardar este dinheiro',
        simulateNew: 'Ver sugestão',
        hideSimulator: 'Ocultar sugestão',
        favorite: 'favorito',
        noPlanYet: 'Ainda não viste a sugestão de onde guardar. É opcional.',
        moreProducts: '+{count} opções na sugestão completa',
      },
      peace: {
        monthsLabel: 'meses cobertos',
        monthsTarget: 'de {n} meses (meta)',
        statusTemplate: 'Estás protegido para {protected}',
        protectedStart: 'o teu arranque',
        protectedOne: '1 mês',
        protectedMany: '{n} meses',
        moneyTemplate: 'Tens <b>{saved}</b> · meta <b>{target}</b> ({months} meses)',
        goalGapTemplate: 'Faltam {gap} para a segurança básica',
        goalComplete: 'Meta atingida, estás protegido',
        awaitingSelfies: 'Regista mais {count} selfie(s) para calcularmos os meses com precisão.',
        healthCoverage: 'Para uma despesa total média de {amount}/mês, este fundo cobre {n} meses.',
      },
      howToReach: {
        title: 'Como lá chegas',
        savingLabel: 'A guardar',
        savingValue: '{monthly}/mês',
        reachLabel: 'Chegas à meta em',
        progressRow: 'Progresso este ano',
        encouragement: {
          empty: 'Define a tua meta e marca o dinheiro que já tens guardado: o primeiro passo é o mais importante.',
          started: 'Já começaste: cada mês conta. Continua ao teu ritmo.',
          building: 'Já cobres quase {months} meses: começaste, que é o que importa. Continua ao teu ritmo.',
          solid: 'Tens uma base sólida. Mantém o ritmo ou explora como optimizar onde guardas.',
        },
      },
      stored: {
        title: 'Onde está guardado',
        subtitle: '{count} sítios · {total}',
        editCta: 'Editar alocações',
      },
      capital: {
        title: 'Distribuição do teu capital',
        efSlice: 'Fundo de emergência',
        investmentSlice: 'Em investimento',
        savingsSlice: 'Poupança (não alocada)',
        roleProtected: 'segurança',
        roleInvested: 'crescimento',
        roleIdle: 'sem destino',
        footAllocated: '{pct}% do capital com destino',
        footIdle: '{pct}% por alocar',
        // .pen `ds/chart/donut · capital` › `foot` (label + valor separados)
        footAllocatedLabel: 'Com destino',
        footIdleLabel: 'Por alocar',
        rowPct: '{pct} % do capital',
        totalLabel: 'capital total',
        avgExpenses: 'Despesa média ({count} selfies): {amount}/mês',
        detailCta: 'Ver fundo de emergência',
      },
      advanced: {
        title: 'Onde guardar este dinheiro',
        subtitle: 'Opcional · quando o fundo crescer',
        badge: 'Avançado',
      },
      empty: {
        heroTitle: 'Ainda não tens rede de segurança. Vamos construí-la?',
        body: 'Um fundo de emergência é <b>dinheiro guardado para imprevistos</b>, para um susto não te desequilibrar. Definimos a tua meta em poucos passos.',
        steps: [
          'Percebes para que serve',
          'Dizes quanto gastas por mês',
          'Escolhes quantos meses cobrir',
          'Marcas o que já tens guardado',
        ],
        cta: 'Construir a minha rede de segurança',
        comingSoonTitle: 'Fundo de Emergência',
        comingSoonBody:
          'Regista a tua primeira selfie financeira para calcularmos a tua rede de segurança.',
      },
    },
    wizard: {
      title: 'Fundo de emergência',
      stepLabel: 'Passo {current} de {total}',
      stepTitles: {
        intro: 'Entender',
        expenses: 'Gastos por mês',
        months: 'Meses a cobrir',
        allocations: 'Alocação',
        done: 'Pronto',
        split: 'Configurar o fundo',
        confirm: 'Resumo',
        health: 'Saúde do fundo',
        plan: 'Plano por risco',
      },
      intro: {
        eyebrow: 'Entender',
        title: 'O que é um fundo de emergência?',
        subtitle: 'Antes de definir a meta, vale a pena perceberes para que serve.',
        howItWorks: 'Como funciona',
        body:
          'Um fundo de emergência é dinheiro de lado só para imprevistos: o carro que avaria, um mês mais fraco. Não é para gastar no dia-a-dia.',
        points: [
          'Começa pequeno: mesmo 500 € já te dão folga para respirar.',
          'Guarda um pouco de cada vez. A meta ideal são 3 meses das tuas despesas.',
          'Só lhe tocas em emergências reais. É a tua rede de segurança.',
        ],
        cta: 'Percebi, continuar',
      },
      expenses: {
        eyebrow: 'A base do cálculo',
        title: 'Quanto gastas por mês?',
        hint: 'É o que vamos multiplicar pelos meses que quiseres cobrir.',
        currencySuffix: '€ / mês',
        prefill:
          'Estimámos {amount}/mês com base nos teus dados. Ajusta se quiseres.',
      },
      months: {
        eyebrow: 'A tua meta',
        title: 'Quantos meses queres cobrir?',
        subtitle:
          'Escolhe só uma coisa: quanto tempo aguentas se o rendimento parar. Do resto tratamos nós.',
        monthsUnit: 'meses',
        monthSingular: 'mês',
        monthShort: 'meses',
        breakdown: '{months} × {spend} € por mês',
        marks: {
          breath: { num: '1 mês', name: 'primeiro respiro' },
          basic: { num: '3', name: 'segurança básica' },
          recommended: { num: '6', name: 'recomendado' },
          calm: { num: '12', name: 'tranquilidade total' },
        },
        milestoneMin: {
          title: 'Primeiro respiro',
          desc: 'Um mês cobre imprevistos pequenos: é o primeiro passo.',
        },
        milestoneBasic: {
          title: 'Segurança básica',
          desc: 'Três meses cobrem a maioria dos imprevistos sérios. Ótimo ponto de partida.',
        },
        milestoneSolid: {
          title: 'Recomendado',
          desc: 'Seis meses dão margem para situações mais longas, como desemprego.',
        },
        milestoneExtended: {
          title: 'Tranquilidade total',
          desc: 'Mais meses significam ainda mais tranquilidade, escolhe o que te faz sentir protegido.',
        },
        recommended: 'Recomendado',
        liveTargetLabel: 'A tua meta fica em',
        split: {
          title: 'Como fica repartido',
          immediateTitle: '{amount} para chegar já',
          immediateBody:
            'dinheiro a que acedes no próprio dia, para o imprevisto que não espera.',
          growingTitle: '{amount} a render',
          growingBody:
            'o resto pode ganhar juros; disponível em poucos dias se precisares.',
          footer:
            'Fazemos esta divisão por ti. Não precisas de mexer, só de escolher os meses.',
        },
      },
      done: {
        title: 'Estás protegido para {protected}',
        hint: 'É o teu ponto de partida. Cada euro que juntares estica ainda mais esta rede de segurança.',
        protectedStart: 'o teu arranque',
        protectedOne: '1 mês',
        protectedMany: '{n} meses',
        metaLabel: 'meta {target}',
        rows: {
          target: 'Meta ({months} meses)',
          saved: 'Já tens guardado',
          gap: 'Ainda falta',
          suggestion: 'Sugestão mensal',
        },
        suggestionValue: '{monthly} / mês',
        suggestionComplete: 'Meta atingida',
        etaTip:
          'A este ritmo, chegas à meta em {months} meses. Guardamos-te um lembrete suave a cada fecho de ciclo.',
        cta: 'Concluir',
      },
      introCta: 'Percebi, continuar',
      continueCta: 'Continuar',
      defineTargetCta: 'Definir esta meta',
      skipLater: 'Saltar, faço isto depois',
      allocations: {
        eyebrow: 'Ponto de partida',
        title: 'Que dinheiro já conta para isto?',
        hint: 'Marca os ativos e define quanto afectas ao fundo. Podes alocar apenas parte do saldo.',
        available: 'Saldo: {amount}',
        amountLabel: 'Afectado ao fundo',
        amountPlaceholder: '0',
        amountExceedsBalance: 'Não pode exceder {balance}',
        sumLabel: 'Já tens guardado',
        ofTarget: '{pct}% da meta ({target})',
        noAccounts: 'Adiciona ativos activos antes de marcar o que já conta.',
      },
      health: {
        lead: 'Compara o que já alocaste com os alvos definidos. Se faltar, podes criar um objectivo SMART para reforçar o fundo.',
        statusLabels: {
          healthy: 'Fundo saudável: mantém o ritmo.',
          oversized: 'Fundo acima do alvo: podes rever a alocação.',
          building: 'Fundo em construção: continua a reforçar.',
          insufficient: 'Fundo abaixo do alvo: prioriza reforço.',
          insufficient_data: 'Precisas de 3 selfies para medir meses cobertos.',
        },
        baseLine: 'Liquidez imediata',
        efLine: 'Fundo de Emergência',
        monthsCovered: 'Cobres cerca de {months} meses de despesas (média dos últimos 3 selfies).',
        gapTitle: 'Falta reforçar o fundo',
        gapDetail:
          'Lacuna estimada: {gap}. Sugestão: ~{monthly}/mês até ao horizonte planeado.',
        createGoalCta: 'Criar objectivo (personalizar)',
        quickCreateCta: 'Criar objectivo sugerido',
        goalCreated: 'Objectivo de reforço criado.',
        goalError: 'Não foi possível criar o objectivo.',
        healthyMessage:
          'O fundo está alinhado com a meta, quando quiseres, podes ver onde guardar o dinheiro.',
        suggestedGoalName: 'Reforço Fundo de Emergência',
        suggestedGoalDescription: 'Completar a meta do fundo de emergência.',
      },
      plan: {
        eyebrow: 'Opcional · para quem quer ir mais longe',
        title: 'Onde guardar este dinheiro?',
        subtitle:
          'Uma sugestão para o teu fundo render sem perder segurança. Se preferires, deixa tudo numa conta só, também funciona.',
        badgeOptional: 'Extra · opcional',
        badgeAdvanced: 'avançado',
        disclaimer:
          'Sugestão indicativa. Não substitui aconselhamento profissional, podes ignorá-la quando quiseres.',
        benefits: {
          immediate: {
            title: 'Acesso imediato',
            body: 'Chegas ao dinheiro no próprio dia. Para o imprevisto que não pode esperar.',
          },
          yield: {
            title: 'Rende mais',
            body: 'Ganha juros enquanto está parado. Demora alguns dias a levantar.',
          },
          safe: {
            title: 'Muito seguro',
            body: 'Garantido pelo Estado (certificados). Rende devagar, risco quase nulo.',
          },
        },
        applyCta: 'Aplicar sugestão',
        skipCta: 'Deixar tudo numa conta só',
        appliedToast: 'Sugestão guardada. Podes voltar quando quiseres.',
        simulateError: 'Não foi possível preparar a sugestão.',
        loadingHint: 'A preparar a sugestão…',
      },
      splitAvgRequired: 'Indica uma despesa média mensal positiva.',
      monthsRequired: 'Escolhe quantos meses queres cobrir.',
      savedToast: 'Rede de segurança configurada.',
      finishCta: 'Ver o meu fundo',
    },
    selfieReview: {
      title: 'Rever o Fundo de Emergência',
      description:
        'Com 3 selfies já conseguimos estimar a tua saúde financeira. Confirma se a alocação dos ativos ainda reflecte o plano.',
      monthsCovered: 'Meses cobertos (estimativa): {months}',
      avgExpenses: 'Despesa média (últimos 3 selfies): {amount}/mês',
      expensesAbove: 'As despesas médias subiram acima do planeado no objectivo.',
      reviewAllocationsCta: 'Rever alocação do fundo',
      dismissCta: 'Continuar',
    },
    dashboardBanner: {
      noAllocations:
        'Configuraste alvos mas ainda não alocaste ativos ao fundo. Rever alocação.',
      cta: 'Alocar agora',
    },
    alerts: {
      expensesAbove: 'Despesas médias acima do planeado no fundo de emergência.',
      belowTarget: 'Fundo de emergência abaixo do objectivo.',
      allocationDrift: 'Alocação dos ativos não coincide com os alvos.',
      reviewAllocations: 'Rever alocação do fundo após a selfie.',
    },
  },
  // CHANGE v2 §23: secção `products` removida (módulo eliminado).
  onboardingEmergencyFund: {
    title: 'A tua rede de segurança',
    subtitle:
      'Dinheiro guardado para imprevistos: define quantos meses de despesas queres cobrir e marca o que já tens guardado.',
    bullets: [
      'Percebes para que serve o fundo de emergência.',
      'Dizes quanto gastas por mês e quantos meses queres cobrir.',
      'Marcas o dinheiro que já tens guardado para imprevistos.',
    ],
    primaryCta: 'Construir a minha rede de segurança',
    secondaryCta: 'Mais tarde',
  },
};

export default pt;
